<template>
  <div class="relative flex flex-col w-full h-full bg-white overflow-hidden">
  <div ref="adminHome"
       class="flex flex-col w-full flex-1 min-h-0 justify-start items-center md:items-start overflow-y-auto md:overflow-hidden bg-white pt-2 md:pt-0">
<!--    <div-->
<!--      v-if="showReferralBanner"-->
<!--      class="w-full px-3 pt-3 pb-1 flex-none"-->
<!--    >-->
<!--      <div class="referral-card" @click="openReferralBanner">-->
<!--        <div class="referral-card__inner">-->
<!--          <i-->
<!--            class="pi pi-times absolute top-0 left-0 hover:text-gray-700 p-2 z-[201] cursor-pointer text-black"-->
<!--            @click.stop="dismissReferralBanner"-->
<!--          />-->
<!--          <div class="flex flex-col z-[200] gap-2 text-gray-800">-->
<!--            <span class="font-medium">הזמינו חברים וקבלו 75₪</span>-->
<!--            <span class="text-xs text-pretty pe-10">על כל עסק שיצטרף בהמלצתכם תקבלו שובר ביימי בשווי 75₪</span>-->
<!--          </div>-->
<!--          <img class="absolute w-20 rotate-45 -bottom-5 -left-5" src="../../../assets/img/admin/referral-img.png" alt="" />-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="px-2 w-full mb-4 lg:mb-0" v-if="isInTrial && isMainClient">
      <OnboardingChecklist @run-tour="$emit('run-tour')" />
    </div>
    <div
      v-if="isMobile"
      id="date-range-picker"
      ref="dateRangePicker"
      class="shadow-[0_1px_6px_rgb(0,0,0,0.01)] px-3 pt-0 w-full bg-white flex flex-col sticky md:relative -top-2 z-[100]">
      <!-- Month/year label (tap to expand to a month grid) + notification bell.
           The bell lives here because the shared app header is hidden on the mobile Home page. -->
      <div class="flex items-center py-3 select-none">
        <div class="w-9 flex-none flex justify-center">
          <div class="cursor-pointer p-1" @click="openSearch">
            <i class="pi pi-search text-lg text-gray-700" />
          </div>
        </div>
        <div
          class="flex-1 flex items-center justify-center gap-2"
          :class="isPendingView ? '' : 'cursor-pointer'"
          @click="!isPendingView && switchCalendarView()">
          <span class="font-semibold text-base">{{ isPendingView ? 'ממתינים לאישור' : mobileMonthYearLabel }}</span>
          <i v-if="!isPendingView" :class="['pi !text-xs text-gray-400', !calendarOpen ? 'pi-chevron-down' : 'pi-chevron-up']" />
        </div>
        <div class="w-9 flex-none flex justify-center">
          <div class="relative cursor-pointer p-1" @click="openNotificationsFromHome">
            <i class="pi pi-bell text-lg text-gray-700" />
            <span v-if="hasUnviewedNotifications" class="absolute top-0.5 right-0.5 w-2 h-2 rounded-full bg-primary border-2 border-white" />
          </div>
        </div>
      </div>

      <HomeDatePicker
        v-if="!isPendingView"
        :model-value="selectedDate"
        :view-date="pickerViewDate"
        :expanded="calendarOpen"
        :event-dates="eventDateSet"
        @update:model-value="onPickerSelect"
        @update:view-date="onPickerViewChange"
      />

      <!-- Unified staff & branch picker (right, RTL) + segmented List/Day/Week control (left) -->
      <div class="flex items-center justify-between gap-2 pt-3 relative">
        <div
          v-if="shouldShowClientsChips"
          class="flex items-center gap-2 cursor-pointer min-w-0"
          @click="staffPickerOpen = !staffPickerOpen"
        >
          <div class="flex flex-none">
            <Avatar
              v-for="(p, i) in staffFilterAvatars"
              :key="p.userId"
              :image="p.profileImage"
              :label="!p.profileImage ? getInitials(p.fullName) : undefined"
              shape="circle"
              class="!w-7 !h-7 !text-[10px] border-2 border-white"
              :style="i > 0 ? { marginInlineStart: '-10px' } : {}"
            />
          </div>
          <span class="text-sm text-gray-700 truncate">{{ staffFilterLabel }}</span>
          <i class="pi pi-chevron-down !text-[9px] text-gray-600 flex-none" />
        </div>
        <div v-else-if="soloProviderDisplay" class="flex items-center gap-2 flex-none">
          <Avatar
            :image="soloProviderDisplay.profileImage"
            :label="!soloProviderDisplay.profileImage ? getInitials(soloProviderDisplay.fullName) : undefined"
            shape="circle"
            class="!w-7 !h-7 !text-[10px]"
          />
          <span class="text-sm font-medium text-gray-700">{{ soloProviderDisplay.fullName }}</span>
        </div>
        <div v-else />

        <div class="flex bg-gray-100 rounded-lg p-0.5 flex-none">
          <button
            v-for="opt in mobileViewOptions"
            :key="opt.key"
            type="button"
            class="px-3 py-1.5 rounded-md text-xs transition-colors flex items-center gap-1"
            :class="currentView.key === opt.key ? 'bg-white text-primary font-medium shadow-sm' : 'text-gray-500'"
            @click="selectMobileView(opt.key)"
          >
            {{ opt.label }}
            <span
              v-if="opt.key === 'pending' && pendingCount"
              class="text-[9.5px] font-semibold text-yellow-700 bg-yellow-100 rounded-full px-1.5 leading-[15px]"
            >{{ pendingCount }}</span>
          </button>
        </div>

        <div
          v-if="staffPickerOpen"
          class="absolute top-full right-0 mt-2 z-30 bg-white rounded-xl border border-gray-200 shadow-lg py-1.5 min-w-[230px] max-h-80 overflow-y-auto"
        >
          <!-- Weekly is scoped to a single employee — say so instead of silently
               dropping the group options. -->
          <div v-if="!isMultiStaffAllowed" class="text-[10.5px] text-gray-400 px-4 pt-1 pb-1.5">
            בתצוגה שבועית בוחרים עובד אחד
          </div>
          <div
            v-if="isMultiStaffAllowed"
            class="flex items-center gap-2.5 px-3 py-2.5 cursor-pointer rounded-lg mx-1"
            :class="staffFilterMode === 'all' ? 'bg-primary-50 text-primary font-medium' : 'hover:bg-gray-50'"
            @click="pickAllStaff"
          >
            <i class="pi pi-users text-gray-400 text-sm flex-none" />
            <span class="text-sm flex-1">כל הצוות</span>
          </div>

          <template v-if="hasBranches">
            <template v-for="group in mobileBranchGroups" :key="group.id">
              <!-- Branch headers stay visible in weekly (they group the staff below)
                   but stop acting as a whole-branch filter there. -->
              <div
                class="flex items-center gap-2.5 px-3 py-2.5 rounded-lg mx-1"
                :class="[
                  isMultiStaffAllowed ? 'cursor-pointer' : 'cursor-default',
                  staffFilterMode === 'branch' && selectedBranch === group.id
                    ? 'bg-primary-50 text-primary font-medium'
                    : isMultiStaffAllowed ? 'hover:bg-gray-50' : ''
                ]"
                @click="pickBranch(group.id)"
              >
                <i class="pi pi-map-marker text-gray-400 text-xs flex-none" />
                <span class="text-sm flex-1 truncate">{{ group.name }}</span>
                <span v-if="isMultiStaffAllowed" class="text-xs text-gray-400 flex-none">כל הסניף</span>
              </div>
              <div
                v-for="provider in group.providers"
                :key="provider.userId"
                class="flex items-center gap-2.5 py-2 pe-4 ps-8 cursor-pointer rounded-lg mx-1"
                :class="staffFilterMode === 'provider' && selectedProvider === provider.userId ? 'bg-primary-50 text-primary font-medium' : 'hover:bg-gray-50'"
                @click="pickProvider(provider.userId)"
              >
                <Avatar
                  :image="provider.profileImage"
                  :label="!provider.profileImage ? getInitials(provider.fullName) : undefined"
                  shape="circle"
                  class="!w-6 !h-6 !text-[9px] flex-none"
                />
                <span class="text-sm flex-1 truncate">{{ provider.fullName }}</span>
              </div>
            </template>
          </template>
          <template v-else>
            <div
              v-for="provider in providers"
              :key="provider.userId"
              class="flex items-center gap-2.5 px-3 py-2.5 cursor-pointer rounded-lg mx-1"
              :class="staffFilterMode === 'provider' && selectedProvider === provider.userId ? 'bg-primary-50 text-primary font-medium' : 'hover:bg-gray-50'"
              @click="pickProvider(provider.userId)"
            >
              <Avatar
                :image="provider.profileImage"
                :label="!provider.profileImage ? getInitials(provider.fullName) : undefined"
                shape="circle"
                class="!w-7 !h-7 !text-[10px] flex-none"
              />
              <span class="text-sm flex-1 truncate">{{ provider.fullName }}</span>
            </div>
          </template>
        </div>
        <div v-if="staffPickerOpen" class="fixed inset-0 z-20" @click="staffPickerOpen = false" />
      </div>

      <!-- "Today" jump (left) + selected date / visible range (right) -->
      <div v-if="!isPendingView" class="flex items-center justify-between gap-2 pt-3 mb-2">
        <div class="flex items-center gap-2 text-sm text-gray-700">
          <i class="pi pi-calendar !text-sm text-gray-400" />
          <span class="font-medium">{{ calendarRangeLabel }}</span>
        </div>
        <button
          type="button"
          class="px-4 py-1.5 rounded-full text-[13px] border transition-colors flex-none"
          :class="isViewingToday
            ? 'border-gray-200 text-gray-500 bg-white'
            : 'border-primary-200 text-primary bg-primary-50 font-medium'"
          @click="goToToday"
        >היום</button>
      </div>
    </div>
    <div v-if="isMobile && currentView.key === 'day' && !isPendingView" class="w-full px-3 mt-2">
      <DayTasksCard :date="selectedDate" :assigneeIds="tasksAssigneeIds" />
    </div>
    <div ref="calendarWrapper" class="calendar-wrapper mt-2 md:mt-0">
      <!-- Mobile: keep original gated loading behavior -->
      <template v-if="isMobile">
        <!-- Pending approval: a flat list of every appointment awaiting a decision.
             Loads independently of the calendar, so it isn't gated on `showLoading`. -->
        <div v-if="isPendingView" class="w-full h-full flex flex-col">
          <div class="flex-1 overflow-y-auto px-3">
            <PendingApprovalsView
              :events="pendingAppointments"
              :loading="pendingLoading"
              :error="pendingError"
              :multi-staff="selectedProvidersList.length > 1"
              :staff-name-of="getListEventStaffName"
              :color-of="getEventColorStyle"
              @event="onPendingEventClick"
              @pick-day="onPendingPickDay"
              @retry="loadPendingAppointments"
            />
          </div>
        </div>
        <div v-else-if="!showLoading" id="amount-appointments" class="w-full h-full flex flex-col">
          <!-- List view: week-at-a-glance day rows with occupancy tracks -->
          <div v-if="currentView.key === 'list'" class="flex-1 overflow-y-auto">
            <WeekCapacityView
              :days="capacityDays"
              :track-start="listTrackRange.start"
              :track-end="listTrackRange.end"
              :multi-staff="selectedProvidersList.length > 1"
              :staff-name-of="getListEventStaffName"
              :color-of="getEventColorStyle"
              :staff-color-of="selectedProvidersList.length > 1 ? staffColorForEvent : undefined"
              :legend="selectedProvidersList.length > 1 ? staffColorLegend : undefined"
              :now-hour="nowFraction"
              @event="onListItemClick"
              @pick-day="onWeekPickDay"
            />
          </div>

          <!-- Weekly — single-employee week time-grid -->
          <div v-else-if="currentView.key === 'week'" class="flex-1 overflow-y-auto">
            <WeekGridView
              :days="weekDaysList"
              :events="weekEvents"
              :start-hour="weekHourRange.start"
              :end-hour="weekHourRange.end"
              :today-iso="todayIso"
              :color-of="getEventColorStyle"
              :now-hour="nowFraction"
              :hour-height-scale="calendarRowHeightScale"
              @event="onTableEventClick"
              @pick-day="onWeekPickDay"
            />
          </div>

          <!-- Daily · multiple employees — "tablish" per-employee columns -->
          <div v-else-if="isMultiProviderDay" class="flex-1 overflow-y-auto"
               @touchstart.passive="onDayTouchStart" @touchend.passive="onDayTouchEnd">
            <DayColumnsView
              :columns="dayColumns"
              :events="selectedDayEvents"
              :start-hour="dayHourRange.start"
              :end-hour="dayHourRange.end"
              :color-of="getEventColorStyle"
              :now-hour="dayNowHour"
              :hour-height-scale="calendarRowHeightScale"
              :closed-ranges-of="closedRangesForProvider"
              @event="onTableEventClick"
              @slot-click="onDayColumnSlotClick"
            />
          </div>

          <!-- Daily · single employee — vue-cal (always shown so empty days stay
               tappable for scheduling) -->
          <div v-else class="h-full flex-1 delicate-day-view"
               @touchstart.passive="onDayTouchStart" @touchend.passive="onDayTouchEnd">
            <vue-cal
              :editableEvents="{ title: false, drag: !isTouch, resize: false, delete: false, create: false }"
              :events="events"
              :hideTitleBar="true"
              :hideViewSelector="true"
              :selectedDate="selectedDate"
              :startWeekOnSunday="true"
              :timeCellHeight="calendarRowHeight"
              :timeFrom="START_OF_DAY * 60"
              :timeTo="END_OF_DAY * 60"
              :specialHours="specialHours"
              :activeView="currentView?.key"
              :split-days="mobileDaySplitColumns"
              :hideWeekdays="hideWeekdays"
              class="md:pt-4"
              locale="he"
              :snapToTime="15"
              @cell-click="onCellClicked"
              @event-click="onEventClick"
              @event-focus="onCalendarEventFocus"
              @event-drop="onEventDrop"
            >
              <template #time-cell="{ hours, minutes }">
                <div
                  class="vuecal__time-cell-line"
                  style="display: flex; justify-content: center;">
                  <span v-if="hours !== 0" style="font-size: 14px; font-weight: 500; position: relative; top: -8px;">
                    {{ hours > 9 ? hours : `0${hours}` }}:{{ minutes > 9 ? minutes : `0${minutes}` }}
                  </span>
                </div>
              </template>

              <template #event="{ event }">
                <div
                  v-if="getEventColorStyle(event)"
                  class="absolute inset-0 rounded-lg pointer-events-none"
                  :style="{ background: getEventColorStyle(event)!.wrapperBackground, border: getEventColorStyle(event)!.border }" />
                <div
                  class="w-full flex gap-1.5 p-0 h-full items-stretch justify-start relative overflow-hidden transition-transform"
                  :class="liftedEventId === event.id ? 'scale-[1.02] opacity-80' : ''"
                  @touchstart="onEventTouchStart(event, $event)"
                  @touchmove="onEventTouchMove"
                  @touchend="onEventTouchEnd"
                  @touchcancel="onEventTouchEnd">
                  <appointment-status-badge
                    :event="event"
                    :size="isRoomyEvent(event) ? '1.125rem' : '0.875rem'"
                    class="absolute top-0.5 left-0.5" />
                  <div v-if="event.type !== 'manual'" id="appointment-line"
                       class="w-1 flex-none rounded-full self-stretch"
                       :style="getEventColorStyle(event) ? { backgroundColor: getEventColorStyle(event)!.lineBg } : {}"></div>
                  <div
                    class="w-full min-w-0 flex flex-col justify-start items-start text-start leading-tight overflow-hidden"
                    :class="getAppointmentStatusMark(event) ? 'pe-6' : ''">
                    <!-- Tight blocks: name - service on one line -->
                    <template v-if="!isRoomyEvent(event)">
                      <div
                        v-if="showEventText(event)"
                        class="w-full flex items-center gap-1 min-w-0">
                        <appointment-markers :event="event" size="0.7rem" />
                        <span
                          class="min-w-0 flex-1 truncate font-normal text-start"
                          :class="eventPrimaryTextClass(event)">
                          {{ getEventTitleLine(event) }}
                        </span>
                      </div>
                    </template>
                    <!-- Roomy blocks: name and service on separate lines -->
                    <template v-else>
                      <div class="w-full flex items-center gap-1 min-w-0">
                        <appointment-markers :event="event" size="0.75rem" />
                        <span
                          class="min-w-0 flex-1 truncate font-normal text-start"
                          :class="eventPrimaryTextClass(event)">
                          {{ getEventPrimaryText(event) }}
                        </span>
                      </div>
                      <span
                        v-if="getEventSecondaryText(event)"
                        class="w-full text-gray-600 font-normal text-start"
                        :class="eventSecondaryTextClass(event)">
                        {{ getEventSecondaryText(event) }}
                      </span>
                    </template>
                    <!-- Time range — shown once the block is tall enough to hold it -->
                    <span
                      v-if="showEventTimeRange(event)"
                      class="text-gray-500 font-normal text-start mt-0.5 text-[11px]"
                      style="direction: ltr;">
                      {{ event.start.formatTime('HH:mm') }} - {{ event.end.formatTime('HH:mm') }}
                    </span>
                  </div>
                </div>
              </template>
            </vue-cal>
          </div>
        </div>
        <retry-loader
          v-else
          :isErrorState="isErrorState"
          @retry-function="tryToLoad" />
      </template>

      <!-- Desktop: per-section skeletons, always render layout -->
      <div v-else class="w-full h-full min-h-0 flex flex-row">
        <!-- Left sidebar -->
        <div class="flex flex-col border-l flex-none px-6 py-5 bg-white overflow-y-auto h-full">
          <!-- Calendar skeleton -->
          <template v-if="!calendarLoaded">
            <div class="flex flex-col gap-2 items-center mb-4">
              <Skeleton width="10rem" height="1.25rem" borderRadius="0.5rem" class="mb-2" />
              <div v-for="row in 6" :key="row" class="flex gap-1">
                <Skeleton v-for="col in 7" :key="col" width="2rem" height="2rem" borderRadius="0.5rem" />
              </div>
            </div>
          </template>
          <template v-else>
            <FullCalendar
              v-model="selectedDate"
              mode="compact"
              items-bg="#fff"
              @update:model-value="(date: Date) => setSelectedDateAtCalendar(DateTime.fromJSDate(date), false)"
              @month-change="(date: Date) => { const dt = DateTime.fromJSDate(date, { zone: 'Asia/Jerusalem' }).startOf('month'); setSelectedDateAtCalendar(dt, false); checkAndFetchNewMonth(dt); }"
              :events="desktopCalendarEvents"
            />
          </template>
          <Divider />
          <DayTasksCard :date="selectedDate" variant="sidebar" :assigneeIds="tasksAssigneeIds" />
          <Divider />
          <!-- Providers — always show immediately (data from adminStore) -->
          <div class="flex flex-col">
            <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-2">עובדים</span>
            <div v-for="(provider, index) in providers"
                 :key="provider.userId"
                 :style="{ transitionDelay: `${index * 50}ms` }"
                 @click="selectProviderToShow(provider.userId)"
                 :class="['w-full py-4 flex gap-3 justify-start items-center border-gray-200 cursor-pointer', index !== providers.length - 1 ? 'border-b' : '']">
              <Avatar
                shape="circle"
                :image="provider.profileImage"
                class="rounded-2xl text-white" />
              <div class="flex flex-grow justify-between items-center">
                <div class="flex flex-col gap-1 items-start justify-start">
                  <span class="font-medium">{{ provider.fullName }}</span>
                </div>
                <i
                  :class="['pi', !selectedProvidersToShow.includes(provider.userId) ? 'pi-circle': 'pi-circle-fill']" />
              </div>
            </div>
          </div>
        </div>

        <!-- Main area -->
        <div class="h-full flex-1 min-h-0 flex flex-col">
          <!-- Toolbar — always show immediately -->
          <div class="w-full px-5 py-3 flex gap-3 items-center border-b border-gray-100 bg-white flex-wrap">
            <Select v-model="currentView"
                    :pt="{ root: { class: 'text-sm !border-gray-200 !rounded-lg ps-2' }, input: { class: 'py-1 px-2 text-sm' }, label: {class: 'font-medium px-2'} }"
                    :options="calendarViews" optionLabel="title" class="flex-none" />
            <div v-if="!isPendingView" class="rounded-lg border border-gray-200 flex justify-center items-center me-auto">
              <i class="pi pi-chevron-right text-gray-400 px-4 !text-sm cursor-pointer"
                 @click="clickedDateToggle('prev')" />
              <span class="font-medium px-3 py-2.5 flex-none text-sm border-x">
                  {{ toggleDatesTitle }}
              </span>
              <i class="pi pi-chevron-left text-gray-400 px-4 !text-sm cursor-pointer"
                 @click="clickedDateToggle('next')" />
            </div>
            <div v-else class="me-auto" />

            <button
              type="button"
              class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 text-sm text-gray-500 hover:bg-gray-50 transition-colors flex-none"
              @click="openSearch"
            >
              <i class="pi pi-search !text-sm" />
              <span>חיפוש לקוח/ה</span>
            </button>

            <div v-if="canEdit" class="flex gap-3 items-center">
              <ActionButton
                v-for="(action, index) in actions.filter(ac => !ac.hideOnDesktop)"
                :key="action.id"
                :label="action.label"
                :desktopLabel="action.desktopLabel"
                :icon="action.icon"
                @action="action.action"
                :is-primary="index === 0"
              />
              <PaymentActionButtons />
            </div>
          </div>

          <!-- Pending approval list — date-independent, so it renders instead of the grid -->
          <div v-if="isPendingView" class="flex-1 min-h-0 overflow-y-auto px-5 py-4">
            <PendingApprovalsView
              :events="pendingAppointments"
              :loading="pendingLoading"
              :error="pendingError"
              :multi-staff="selectedProvidersList.length > 1"
              :staff-name-of="getListEventStaffName"
              :color-of="getEventColorStyle"
              @event="onPendingEventClick"
              @pick-day="onPendingPickDay"
              @retry="loadPendingAppointments"
            />
          </div>
          <!-- Events area — skeleton while loading or month switching -->
          <div v-else-if="!eventsLoaded || monthSwitchLoading" class="flex flex-col gap-4 p-6">
            <div v-for="i in 6" :key="i" class="flex gap-3 items-center">
              <Skeleton width="3.5rem" height="1rem" borderRadius="0.5rem" />
              <Skeleton width="100%" height="4rem" borderRadius="0.75rem" />
            </div>
          </div>
          <!-- Error state for desktop -->
          <retry-loader
            v-else-if="isErrorState"
            :isErrorState="isErrorState"
            @retry-function="tryToLoad" />
          <vue-cal
            v-else
            :editableEvents="{ title: false, drag: !isTouch, resize: false, delete: false, create: false }"
            :events="events"
            :hideTitleBar="true"
            :hideViewSelector="true"
            :selectedDate="selectedDate"
            :startWeekOnSunday="true"
            :timeCellHeight="calendarRowHeight"
            :timeFrom="START_OF_DAY * 60"
            :timeTo="END_OF_DAY * 60"
            :specialHours="specialHours"
            :activeView="currentView?.key"
            :split-days="splitDays"
            :hideWeekdays="hideWeekdays"
            class="pt-0 flex-1 min-h-0"
            locale="he"
            :snapToTime="15"
            @cell-click="onCellClicked"
            @event-click="onEventClick"
            @event-focus="onCalendarEventFocus"
            @event-drop="onEventDrop"
          >
            <template #time-cell="{ hours, minutes }">
              <div
                class="vuecal__time-cell-line"
                style="display: flex; justify-content: center;">
                <span v-if="hours !== 0" style="font-size: 14px; font-weight: 500; position: relative; top: -8px;">
                  {{ hours > 9 ? hours : `0${hours}` }}:{{ minutes > 9 ? minutes : `0${minutes}` }}
                </span>
              </div>
            </template>

            <template #event="{ event }">
              <div
                v-if="getEventColorStyle(event)"
                class="absolute inset-0 rounded-lg pointer-events-none"
                :style="{ background: getEventColorStyle(event)!.wrapperBackground, border: getEventColorStyle(event)!.border }" />
              <div
                class="w-full flex gap-1.5 p-0 h-full items-stretch justify-start relative overflow-hidden transition-transform"
                :class="liftedEventId === event.id ? 'scale-[1.02] opacity-80' : ''"
                @touchstart="onEventTouchStart(event, $event)"
                @touchmove="onEventTouchMove"
                @touchend="onEventTouchEnd"
                @touchcancel="onEventTouchEnd">
                <appointment-status-badge
                  :event="event"
                  :size="isRoomyEvent(event) ? '1.125rem' : '0.875rem'"
                  class="absolute top-0.5 left-0.5" />
                <div v-if="event.type !== 'manual'" id="appointment-line" class="w-1 flex-none rounded-full self-stretch"
                     :style="getEventColorStyle(event) ? { backgroundColor: getEventColorStyle(event)!.lineBg } : {}"></div>
                <div
                    class="w-full min-w-0 flex flex-col justify-start items-start text-start leading-tight overflow-hidden"
                    :class="getAppointmentStatusMark(event) ? 'pe-6' : ''">
                  <!-- Tight blocks: name - service on one line -->
                  <template v-if="!isRoomyEvent(event)">
                    <div
                      v-if="showEventText(event)"
                      class="w-full flex items-center gap-1 min-w-0">
                      <appointment-markers :event="event" size="0.7rem" />
                      <span class="min-w-0 flex-1 truncate font-normal text-start"
                            :class="eventPrimaryTextClass(event)">
                        {{ getEventTitleLine(event) }}
                      </span>
                    </div>
                  </template>
                  <!-- Roomy blocks: name and service on separate lines -->
                  <template v-else>
                    <div class="w-full flex items-center gap-1 min-w-0">
                      <appointment-markers :event="event" size="0.75rem" />
                      <span class="min-w-0 flex-1 truncate font-normal text-start" :class="eventPrimaryTextClass(event)">
                        {{ getEventPrimaryText(event) }}
                      </span>
                    </div>
                    <span
                      v-if="getEventSecondaryText(event)"
                      class="w-full text-gray-600 font-normal text-start"
                      :class="eventSecondaryTextClass(event)">
                      {{ getEventSecondaryText(event) }}
                    </span>
                  </template>
                  <!-- Time range — shown once the block is tall enough to hold it -->
                  <span
                    v-if="showEventTimeRange(event)"
                    class="text-gray-500 font-normal text-start mt-0.5"
                    :class="currentView.key === 'week' ? 'text-[10px]' : 'text-[11px]'"
                    style="direction: ltr;">
                    {{ event.start.formatTime('HH:mm') }} - {{ event.end.formatTime('HH:mm') }}
                  </span>
                </div>
              </div>
            </template>
          </vue-cal>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ Docked actions (mobile only) — the "…" morphs the bar itself into the full
       actions panel (no drawer): the dots collapse away so the primary button
       stretches to full width, and the action grid expands below it ═══ -->
  <template v-if="isMobile && canEdit">
    <!-- Dim the whole screen (viewport-fixed, above the app header) while the panel is
         open, but stop above the bottom nav (h-16) so the nav stays bright. -->
    <Transition name="ha-fade">
      <div v-if="actionsExpanded" class="md:hidden fixed inset-x-0 top-0 bottom-16 max-w-[500px] z-[110] bg-black/30" @click="actionsExpanded = false" />
    </Transition>

    <!-- The wrapper keeps the collapsed bar height in the layout (46px button + py-2.5
         + border-t); the panel is anchored to its bottom and grows upward over the
         dimmed calendar when expanded, so nothing behind it reflows. -->
    <div class="md:hidden flex-none relative z-[120] h-[67px]">
      <div
        class="ha-panel absolute inset-x-0 bottom-0 bg-white border-t px-3.5 pt-2.5 pb-2.5"
        :class="actionsExpanded ? 'ha-panel--open border-transparent rounded-t-2xl shadow-[0_-8px_28px_rgba(0,0,0,0.14)]' : 'border-gray-100'"
      >
        <div class="ha-handle">
          <div class="w-9 h-1 rounded-full bg-gray-300 cursor-pointer" @click="actionsExpanded = false" />
        </div>

        <div class="flex items-center">
          <Button
            type="button"
            class="flex-1 shadow-xl md:shadow-none"
            @click="runAction(addCustomerEvent)"
          >
            {{ actionsExpanded ? 'זימון תור חדש' : 'זימון תור' }}
            <i class="pi pi-plus text-sm" />
          </Button>
          <button
            type="button"
            class="ha-dots flex-none rounded-xl border border-gray-200 flex items-center justify-center"
            :tabindex="actionsExpanded ? -1 : 0"
            @click="actionsExpanded = true"
          >
            <i class="pi pi-ellipsis-h text-gray-600" />
          </button>
        </div>

        <div class="ha-sec">
          <div>
            <div class="ha-sec-inner grid grid-cols-2 gap-2.5 pt-3">
              <button
                v-for="action in homeActionsSheetItems"
                :key="action.label"
                type="button"
                class="flex items-center justify-center gap-2.5 py-3.5 rounded-xl border border-gray-200 text-sm active:bg-gray-50"
                @click="runAction(action.action)"
              >
                <i :class="['pi', action.icon, 'text-primary text-base']" />
                <span>{{ action.label }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <CalendarDropIndicator :preview="dragPreview" />

  <ConfirmDialog />
  <RecurringEventActionModal
    :visible="showRecurringDragModal"
    action-type="edit"
    :event-title="recurringDragCtx?.title"
    @update:visible="onRecurringDragModalVisible"
    @action="handleRecurringDragAction" />
  <AiFloatingButton v-if="isAIEnabled && !isMobile" />
  </div>
</template>

<script lang="ts" setup>
import {
  AppointmentStatus,
  AppointmentType,
  AvailabilityOverrideTypeEnum,
  CalendarDefaultView,
  ContractStatus,
  DEFAULT_CALENDAR_ROW_HEIGHT,
  daysMapping,
  ICalendarData,
  ICalendarEvent,
  IClient,
  IStatsData,
  IWorkingHoursItem,
  MAIN_BRANCH_ID,
  PaymentRequestStatus
} from '@torim-app/types';
import ConfirmDialog from 'primevue/confirmdialog';

import { computed, inject, nextTick, onMounted, onUnmounted, reactive, ref, type Ref, watch } from 'vue';
import ShareSocials from '@app/components/admin/modals/ShareSocials.vue';
import SendPaymentRequest from '@app/components/admin/pages/home/SendPaymentRequest.vue';
import DayColumnsView from '@app/components/admin/pages/home/DayColumnsView.vue';
import WeekGridView from '@app/components/admin/pages/home/WeekGridView.vue';
import WeekCapacityView, { ICapacityDay } from '@app/components/admin/pages/home/WeekCapacityView.vue';
import HomeDatePicker from '@app/components/admin/pages/home/HomeDatePicker.vue';
import DayTasksCard from '@app/components/admin/pages/tasks/DayTasksCard.vue';
import { useTaskEditor } from '@app/components/admin/pages/tasks/use-task-editor';
import { TasksApi } from '@app/api/admin/tasks-api';
import HomeSearch from '@app/components/admin/pages/home/HomeSearch.vue';
import PendingApprovalsView from '@app/components/admin/pages/home/PendingApprovalsView.vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { DateTime } from 'luxon';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// eslint-disable-next-line import/extensions
import 'v-calendar/style.css';
import { useAdminAvailabilityStore, useAdminHomeStore, useAdminStore, useAdminTasksStore } from '@app/stores';
import { calendarEventLayout, getColorVariants, getNumericHour, simulateOpacity } from '@torim-app/utils';
import { AdminRouteNames } from '@app/router/route-names';
import { AppointmentsApi } from '@app/api/admin/appointments-api';
import { RecurringEventsApi } from '@app/api/admin/recurring-events-api';
import { useToast } from 'vue-toastification';
import { AdminApi } from '@app/api/admin/admin-api';
import NewCustomerEvent from '@app/components/admin/modals/NewCustomerEvent.vue';
import ManualEvent from '@app/components/admin/modals/ManualEvent.vue';
import { FullCalendar, useDrawer } from '@torim-app/shared-components';
import ExistingEventOptions from '@app/components/admin/modals/ExistingEventOptions.vue';
import ExampleEventOptions from '@app/components/admin/modals/ExampleEventOptions.vue';
import RecurringEventActionModal, { RecurringActionScope } from '@app/components/admin/modals/RecurringEventActionModal.vue';
import { useResponsive } from '@app/composables/responsive';
import Select from 'primevue/select';
import { trackEvent } from '@app/composables/posthog';
import { useRoute, useRouter } from 'vue-router';
import AiFloatingButton from '@app/components/admin/ai/AiFloatingButton.vue';
import { useStorage } from '@app/composables/use-storage';
import { type CalendarDragEvent, isTouchPrimary, useCalendarDrag } from '@app/composables/calendar-drag';
import CalendarDropIndicator from '@app/components/admin/pages/home/CalendarDropIndicator.vue';
import AppointmentMarkers from '@app/components/admin/pages/home/AppointmentMarkers.vue';
import AppointmentStatusBadge from '@app/components/admin/pages/home/AppointmentStatusBadge.vue';
import { getAppointmentStatusMark } from '@app/components/admin/pages/home/appointment-status-mark';

export interface IVueCalDnDEvent {
  event: {
    start: Date;
    end: Date;
    startTimeMinutes: number;
    endTimeMinutes: number;
    title: string;
    background: boolean;
    allDay: boolean;
    daysCount: number;
    class: string;
    duration: number;
    id: string;
    type: AppointmentType;
    status: AppointmentStatus;
    paymentStatus: 'partial' | PaymentRequestStatus.Success;

  };
  oldDate: Date;
  newDate: Date;
  external: boolean;
}

type calendarViewTypes = 'day' | 'week' | 'month' | 'list' | 'pending';

const emit = defineEmits(['run-tour', 'parent-function']);

const refresh = inject<Ref<boolean>>('refresh', ref(false));
const adminStore = useAdminStore();
const adminHomeStore = useAdminHomeStore();
const adminAvailabilityStore = useAdminAvailabilityStore();
const { setPage } = adminStore;
const { setSelectedDateAtCalendar, setProviderId } = adminHomeStore;
const toast = useToast();
const { openDrawer, closeDrawer } = useDrawer();
const { openTaskEditor } = useTaskEditor();
const tasksStore = useAdminTasksStore();
const { isMobile } = useResponsive();
const router = useRouter();
const { getValue, setValue } = useStorage();

// The mobile Home page hides the shared app header, so it renders its own notification
// bell in the calendar month row; opening the panel is delegated to Admin.vue.
const hasUnviewedNotifications = computed(() => (adminStore.notifications ?? []).some(x => !x.viewedAt));
// Search over customers and their appointments — opened from the mobile header and the
// desktop toolbar, so the owner can find a visit without walking the calendar.
const openSearch = () => {
  trackEvent('home_search_opened');
  openDrawer(HomeSearch, {}, {
    title: 'חיפוש',
    noPadding: true,
    full: true
  });
};

const openNotificationsFromHome = () => {
  trackEvent('notifications_opened', { source: 'home_calendar' });
  emit('parent-function', 'openNotifications');
};

const REFERRAL_BANNER_STORAGE_KEY = 'torim_referral_banner_dismissed_v1';
const showReferralBanner = ref(false);

const dismissReferralBanner = async () => {
  showReferralBanner.value = false;
  trackEvent('referral_banner_dismissed');
  try {
    await setValue(REFERRAL_BANNER_STORAGE_KEY, 'true');
  } catch (error) {
    console.error('Error saving referral banner state:', error);
  }
};

const openReferralBanner = async () => {
  trackEvent('referral_invite_clicked', { source: 'home_banner' });
  showReferralBanner.value = false;
  try {
    await setValue(REFERRAL_BANNER_STORAGE_KEY, 'true');
  } catch (error) {
    console.error('Error saving referral banner state:', error);
  }
  router.push({ name: AdminRouteNames.ReferralProgram });
};

const START_OF_DAY = 7;
const END_OF_DAY = 24;
const isCalendarSticky = ref<boolean>(false);
const dateRangePicker = ref<HTMLDivElement>();
const adminHome = ref<HTMLDivElement>();
const calendar = ref(null);
const calendarOpen = ref(false);
const dataLoaded = ref(false);
const isErrorState = ref(false);
const calendarLoaded = ref(false);
const eventsLoaded = ref(false);
const monthSwitchLoading = ref(false);
const initialPage = ref<any>({});
const automaticallyClosed = ref(false);
const PROVIDERS_STORAGE_KEY = `torim_selected_providers_${adminStore.getBusinessSiteData?.bid}`;
const savedProviders = localStorage.getItem(PROVIDERS_STORAGE_KEY);
const selectedProvidersToShow = ref<string[]>(
  // Users who cannot manage others (employees / read-only) must only ever see
  // their OWN calendar — never the whole team's. Requesting multiple providers
  // for such a user fetches everyone's appointments and, since the split view
  // is disabled for them, renders them overlapping in one column.
  !adminStore.getCanManageOthers
    ? (adminStore.userId ? [adminStore.userId] : [])
    : (savedProviders ? JSON.parse(savedProviders) : [...(adminStore.getProviders?.map(p => p.userId) ?? [])])
);
// Mobile never used to expose multi-provider selection — start scoped to the
// logged-in provider there regardless of an "all providers" value persisted
// under this (shared) key from a desktop session. The new mobile staff picker
// lets the owner explicitly opt into "all staff"/"whole branch" from here on.
if (isMobile.value && selectedProvidersToShow.value.length > 1 && adminStore.userId) {
  selectedProvidersToShow.value = [adminStore.userId];
}
const attributes = ref<Array<any>>([
  {
    key: 'today',
    highlight: {
      color: 'purple',
      fillMode: 'light'
    },
    dates: new Date(),
    order: 10
  },
  {
    key: 'selectedDate',
    highlight: {
      color: 'purple',
      fillMode: 'outline'
    },
    dates: new Date(),
    order: 0
  }
]);
const statsData = reactive(<IStatsData>{});
const selectedProvider = ref<string>(adminStore.userId ?? '');
const selectPreDefineDate = ref<Date>();
const currentLoadedMonth = ref<DateTime>(DateTime.local({ zone: 'Asia/Jerusalem' }).startOf('month'));
const currentView = ref<{ title: string; key: calendarViewTypes }>(isMobile.value ? {
  title: 'תצוגה יומית',
  key: 'day'
} : { title: 'תצוגה שבועית', key: 'week' });

const calendarViews = computed<Array<{ title: string; key: calendarViewTypes }>>(() => {
  const response = [] as Array<{ title: string; key: calendarViewTypes }>;

  if (providers.value?.length) {
    response.push({ title: 'תצוגה יומית', key: 'day' });
  }
  response.push(...[
    { title: 'תצוגה שבועית', key: 'week' as calendarViewTypes }
    // { title: 'תצוגה חודשית', key: 'month' as calendarViewTypes }
  ]);
  // Only businesses that approve every booking by hand have something to show here.
  if (manualApproveEnabled.value) {
    response.push({ title: 'ממתינים לאישור', key: 'pending' as calendarViewTypes });
  }

  return response;
});
// Mobile-only segmented control (List / Day / Week, + "pending" for manual-approve
// businesses). Kept fully separate from `calendarViews` above so desktop's dropdown
// never gains a "List" option.
const mobileViewOptions = computed<Array<{ title: string; key: calendarViewTypes; label: string }>>(() => {
  const options: Array<{ title: string; key: calendarViewTypes; label: string }> = [
    { title: 'רשימה', key: 'list', label: 'רשימה' },
    { title: 'תצוגה יומית', key: 'day', label: 'יומי' },
    { title: 'תצוגה שבועית', key: 'week', label: 'שבועי' }
  ];
  if (manualApproveEnabled.value) {
    options.push({ title: 'ממתינים לאישור', key: 'pending', label: 'לאישור' });
  }
  return options;
});
const selectMobileView = (key: calendarViewTypes) => {
  const option = mobileViewOptions.value.find(o => o.key === key);
  if (option) currentView.value = { title: option.title, key: option.key };
};
const HEBREW_MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
const toggleDatesTitle = computed<string>(() => {
  const dateAsDateTime = DateTime.fromJSDate(selectedDate.value);
  if (currentView.value.key === 'day')
    return dateAsDateTime?.toLocaleString(DateTime.DATE_MED);
  else if (currentView.value.key === 'week') {
    const isoDate = dateAsDateTime.toISO();
    const date = DateTime.fromISO(isoDate, { locale: 'he' }).setZone('Asia/Jerusalem');
    const startOfWeek = date.startOf('week', { useLocaleWeeks: true }).toLocaleString(DateTime.DATE_MED);
    const endOfWeek = date.endOf('week', { useLocaleWeeks: true }).toLocaleString(DateTime.DATE_MED);
    return `${startOfWeek} - ${endOfWeek}`;
  } else if (currentView.value.key === 'month') {
    return HEBREW_MONTHS[dateAsDateTime.month - 1];
  }

  return '';
});
// Mobile header row: "⌄ {month} {year}", clickable — reuses the existing
// weekly⇄monthly toggle (switchCalendarView / calendarOpen). Follows the picker's
// anchor so browsing months/weeks updates the label even before a day is picked.
const mobileMonthYearLabel = computed<string>(() => {
  const dt = DateTime.fromJSDate(pickerViewDate.value);
  return `${HEBREW_MONTHS[dt.month - 1]} ${dt.year}`;
});
const splitDays = computed<{ id: string; class?: string; label: string; }[]>(() => {
  if (!providers.value?.length || isMobile.value) return [];

  const filteredProviders = providers.value.filter(p => selectedProvidersToShow.value.includes(p.userId));
  if (filteredProviders.length < 2) return [];

  const splits = filteredProviders.map(p => ({
    label: p.fullName,
    id: p.userId
  }));
  console.log('[splitDays computed]', JSON.stringify(splits));
  return splits;
});
// Compute which weekdays to hide based on provider availability
const hideWeekdays = computed<number[]>(() => {
  // While we're showing the example appointments (brand-new, empty business),
  // show the full week so the examples are always visible regardless of whether
  // the owner has set working hours yet.
  if (showDemoEvents.value) {
    return [];
  }
  if (!adminAvailabilityStore.getAvailability || Object.keys(adminAvailabilityStore.getAvailability).length === 0) {
    return [];
  }

  // Get the providers we're showing (all if desktop with multiple, or selected provider if single/mobile)
  const relevantProviders = isMobile.value || selectedProvidersToShow.value.length === 1
    ? [selectedProvider.value]
    : selectedProvidersToShow.value;

  // Days in vue-cal: 1=Sunday, 2=Monday, ..., 7=Saturday
  // Days enum: SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY
  const daysToCheck = [1, 2, 3, 4, 5, 6, 7]; // All weekdays
  const daysToHide: number[] = [];

  for (const day of daysToCheck) {
    // Check if ANY provider has working hours on this day
    const hasWorkingHours = relevantProviders.some(providerId => {
      const availability = adminAvailabilityStore.getAvailabilityByDay(providerId, day);
      return availability && availability.length > 0;
    });

    // If no provider works on this day, hide it
    if (!hasWorkingHours) {
      daysToHide.push(day);
    }
  }

  return daysToHide;
});
// Calendar density, set by the business in the scheduling settings. The main calendar
// uses the height directly; the compact mobile grids scale by the same ratio so they
// stay proportionally denser.
const calendarRowHeight = computed<number>(() =>
  adminStore.getBusinessSiteData?.configurations?.calendarRowHeight || DEFAULT_CALENDAR_ROW_HEIGHT
);
const calendarRowHeightScale = computed<number>(() => calendarRowHeight.value / DEFAULT_CALENDAR_ROW_HEIGHT);

// Businesses that approve every booking manually get an extra calendar view listing
// everything still waiting for their decision.
const manualApproveEnabled = computed(() => adminStore.getBusinessSiteData?.configurations?.appointmentManualApprove === true);
const isPendingView = computed(() => currentView.value.key === 'pending');
const isAIEnabled = computed(() => adminStore.getBusinessSiteData?.configurations?.adminAiEnabled ?? false);
const isInTrial = computed(() => adminStore.getBusinessSiteData?.contract?.status === ContractStatus.Trial);
const isMainClient = computed(() => adminStore.getMainClient);
const canManageOthers = computed(() => adminStore.getCanManageOthers);
// An employee the owner granted the branch calendar to picks between the same staff a
// manager would — but only those working at their own branch(es).
const canViewBranchCalendar = computed(() => adminStore.getCanViewBranchCalendar);
const canEdit = computed(() => adminStore.getCanEdit);
const providers = computed<Array<Pick<IClient, 'userId' | 'fullName' | 'profileImage'>>>(() => {
  if (canManageOthers.value) return adminStore.getProviders;
  if (!canViewBranchCalendar.value) return [];

  // Branch membership comes from the working-hours blocks; the server only sends this
  // employee the hours of colleagues they're allowed to see, so an empty result simply
  // means "nobody else at my branch".
  const ownBranches = adminAvailabilityStore.getProviderBranchIds(adminStore.userId);
  return adminStore.getProviders.filter(p =>
    p.userId === adminStore.userId
    || adminAvailabilityStore.getProviderBranchIds(p.userId).some(id => ownBranches.includes(id))
  );
});
const shouldShowClientsChips = computed(() => (canManageOthers.value || canViewBranchCalendar.value) && providers.value.length > 1);
// Whose calendar is shown when there's no staff picker: a one-provider business,
// or an employee who only ever sees their own calendar (providers is emptied
// for them above, so their name got lost without this).
const soloProviderDisplay = computed(() => {
  if (shouldShowClientsChips.value) return null;
  if (providers.value.length === 1) return providers.value[0];
  if (!canManageOthers.value && !canViewBranchCalendar.value) {
    return adminStore.getProviders.find(p => p.userId === adminStore.userId) ?? null;
  }
  return null;
});

// ---- Branch filter (calendar) ----
const hasBranches = computed(() => adminStore.hasBranches);
const branchChips = computed(() => adminStore.getBranchSelectOptions);
const selectedBranch = ref<string>(MAIN_BRANCH_ID);
// Providers that work at a given branch. Providers with no working-hours
// branch tag fall back to the main branch (mirrors the "untagged = main" rule).
const providersForBranch = (branchId: string) => providers.value.filter(p => {
  const branchIds = adminAvailabilityStore.getProviderBranchIds(p.userId);
  if (branchIds.length === 0) return branchId === MAIN_BRANCH_ID;
  return branchIds.includes(branchId);
});

// ---- Mobile: unified staff + branch picker (replaces the old chip rows) ----
const staffPickerOpen = ref(false);
const getInitials = (fullName: string): string => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
};
// Branches + their staff, for the unified mobile picker dropdown. A provider
// working across multiple branches is listed only once, under the first
// branch they match (main branch first) — otherwise they'd show up twice.
const mobileBranchGroups = computed(() => {
  if (!hasBranches.value) return [];
  const assigned = new Set<string>();
  return branchChips.value.map(branch => {
    const branchProviders = providersForBranch(branch.id).filter(p => !assigned.has(p.userId));
    branchProviders.forEach(p => assigned.add(p.userId));
    return { ...branch, providers: branchProviders };
  });
});
// Week view is restricted to a single provider — "all staff"/"whole branch"
// only apply to List and Day views (Day can show side-by-side columns).
const isMultiStaffAllowed = computed(() => currentView.value.key !== 'week');
const staffFilterMode = computed<'all' | 'branch' | 'provider'>(() => {
  if (!providers.value.length) return 'provider';
  if (selectedProvidersToShow.value.length === providers.value.length) return 'all';
  if (hasBranches.value) {
    const branchIds = providersForBranch(selectedBranch.value).map(p => p.userId).sort();
    const current = [...selectedProvidersToShow.value].sort();
    if (branchIds.length > 1 && branchIds.length === current.length && branchIds.every((id, i) => id === current[i])) return 'branch';
  }
  return 'provider';
});
const staffFilterLabel = computed(() => {
  if (staffFilterMode.value === 'all') return 'כל הצוות';
  if (staffFilterMode.value === 'branch') return branchChips.value.find(b => b.id === selectedBranch.value)?.name ?? 'כל הצוות';
  return providers.value.find(p => p.userId === selectedProvider.value)?.fullName
    ?? providers.value.find(p => selectedProvidersToShow.value.includes(p.userId))?.fullName
    ?? '';
});
const staffFilterAvatars = computed<Array<Pick<IClient, 'userId' | 'fullName' | 'profileImage'>>>(() => {
  if (staffFilterMode.value === 'all') return providers.value.slice(0, 3);
  if (staffFilterMode.value === 'branch') return providersForBranch(selectedBranch.value).slice(0, 3);
  const p = providers.value.find(p => p.userId === selectedProvider.value);
  return p ? [p] : [];
});

// Set as soon as the staff filter is chosen rather than derived, so the owner-set
// calendar default (see `applyCalendarDefaults`) stops steering it.
let staffFilterTouched = false;
const pickAllStaff = () => {
  if (!isMultiStaffAllowed.value || !providers.value.length) return;
  trackEvent('calendar_provider_changed', { scope: 'all' });
  staffFilterTouched = true;
  selectedProvider.value = providers.value[0].userId;
  selectedProvidersToShow.value = providers.value.map(p => p.userId);
  staffPickerOpen.value = false;
};
const pickBranch = (branchId: string) => {
  if (!isMultiStaffAllowed.value) return;
  const ids = providersForBranch(branchId).map(p => p.userId);
  if (!ids.length) return;
  trackEvent('calendar_branch_changed', { branchId });
  staffFilterTouched = true;
  selectedBranch.value = branchId;
  selectedProvider.value = ids[0];
  selectedProvidersToShow.value = [...ids];
  staffPickerOpen.value = false;
};
const pickProvider = (providerId: string) => {
  trackEvent('calendar_provider_changed');
  staffFilterTouched = true;
  selectedProvider.value = providerId;
  const branchIds = adminAvailabilityStore.getProviderBranchIds(providerId);
  selectedBranch.value = branchIds[0] ?? MAIN_BRANCH_ID;
  selectedProvidersToShow.value = [providerId];
  staffPickerOpen.value = false;
};
// Week view never shows more than one provider — collapse back to a single
// provider if "all staff"/"whole branch" was selected when switching into it.
watch(() => currentView.value.key, (key) => {
  if (key === 'week' && selectedProvidersToShow.value.length > 1) {
    const fallbackId = selectedProvidersToShow.value.includes(selectedProvider.value)
      ? selectedProvider.value
      : selectedProvidersToShow.value[0];
    pickProvider(fallbackId);
  }
});
// Mobile Day view only: side-by-side employee columns when multiple providers
// are selected. Desktop keeps its own `splitDays` below, unaffected.
const mobileDaySplitColumns = computed<{ id: string; label: string }[]>(() => {
  if (!isMobile.value || currentView.value.key !== 'day') return [];
  const selected = providers.value.filter(p => selectedProvidersToShow.value.includes(p.userId));
  return selected.length > 1 ? selected.map(p => ({ id: p.userId, label: p.fullName })) : [];
});

const calendarData = computed<ICalendarData>(() => adminHomeStore.getCalendarData);
const selectedDate = computed(() => adminHomeStore.getSelectedDateAtCalendar);
const showLoading = computed(() => !dataLoaded.value || adminHomeStore.isLoading);

// ── Custom mobile date picker (week strip / month grid) ──
// `pickerViewDate` is the anchor of the shown week/month; it can differ from the
// selected date while the user browses (swipe / month arrows) before tapping a day.
const pickerViewDate = ref<Date>(selectedDate.value);
// ISO dates (yyyy-MM-dd) that have appointments — drive the little dots.
const eventDateSet = computed<Set<string>>(() => {
  const set = new Set<string>();
  for (const e of calendarData.value?.events ?? []) {
    if (e.type === AppointmentType.OUT_OF_OFFICE) continue;
    if (typeof e.id === 'string' && e.id.startsWith('holiday-')) continue;
    const iso = e.start?.split(' ')[0];
    if (iso) set.add(iso);
  }
  return set;
});
const onPickerSelect = (date: Date) => {
  setSelectedDateAtCalendar(DateTime.fromJSDate(date).startOf('day'), false);
  pickerViewDate.value = date;
  if (calendarOpen.value) calendarOpen.value = false; // collapse month grid after picking
};
const onPickerViewChange = (date: Date) => {
  pickerViewDate.value = date;
  checkAndFetchNewMonth(DateTime.fromJSDate(date));
};
const isViewingToday = computed(() =>
  DateTime.fromJSDate(selectedDate.value).hasSame(DateTime.local({ zone: 'Asia/Jerusalem' }), 'day')
);
const goToToday = () => {
  trackEvent('calendar_today_clicked');
  setSelectedDateAtCalendar(DateTime.local({ zone: 'Asia/Jerusalem' }).startOf('day'), false);
};
const maxDate = computed(() => calendarData.value?.dateRange?.to ? DateTime.fromISO(calendarData.value.dateRange.to as string).plus({ month: 6 }).toJSDate() : new Date());
const desktopCalendarEvents = computed(() => {
  if (!calendarData.value?.events?.length) return [];

  return calendarData.value?.events.map(event => {
    return { date: DateTime.fromISO(event.start.split(' ')[0]).toJSDate() };
  });
});
const hexToRgba = (hex: string, alpha: number): string => {
  const h = hex.replace('#', '');
  if (h.length !== 6) return hex;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const getEventColorStyle = (event: ICalendarEvent): { wrapperBackground: string; lineBg: string; border?: string } | null => {
  // Time a task reserved: drawn as the task (hollow, dashed), not as a blocked hour.
  if (event.taskId) return { wrapperBackground: '#ffffff', lineBg: '#8f7fc0', border: '2px dashed #8f7fc0' };
  if (event.type === AppointmentType.OUT_OF_OFFICE) return null;
  // Manual events keep the "blocked" diagonal-stripe feel, tinted in the chosen color; without
  // a chosen color they fall back to the plain blocked-hour styling (null).
  if (event.type === AppointmentType.MANUAL) {
    if (!event.serviceColor) return null;
    const stripe = hexToRgba(event.serviceColor, 0.5);
    return {
      wrapperBackground: `repeating-linear-gradient(45deg, transparent, transparent 4px, ${stripe} 4px, ${stripe} 8px)`,
      lineBg: event.serviceColor
    };
  }
  // Colour says WHICH service; status is shown by a mark (AppointmentMarkers), never by
  // shade — employees couldn't tell a lighter tint from a darker one. The one exception is
  // a booking waiting for the business's approval: it isn't confirmed yet, so it's drawn
  // hollow (white + dashed outline) to read as "not in the diary yet".
  if (event.status === AppointmentStatus.NO_SHOW && !event.serviceColor)
    return { wrapperBackground: '#fff7ed', lineBg: '#f97316' };
  const color = event.serviceColor || '#8864ee';
  if (event.status === AppointmentStatus.WAITING_FOR_BUSINESS_APPROVAL) {
    const { darker } = getColorVariants(color);
    return { wrapperBackground: '#ffffff', lineBg: color, border: `1.5px dashed ${darker}` };
  }
  return { wrapperBackground: simulateOpacity(color, 0.25), lineBg: color };
};

// While a brand-new business is still empty, seed the real calendar with a few
// clearly-labeled example appointments so the first experience isn't a blank
// grid. They're display-only (never sent to the backend) and disappear the
// moment a real appointment exists.
//
// "Has real visits" combines two signals so we never show the examples to a
// business that has already started working:
//   - business-wide: `statsData.futureAppointments` counts upcoming real
//     appointments and is loaded once (not limited to the visible week);
//   - current view: any EVENT/MANUAL row in the loaded calendar (catches past
//     appointments and manual blocks). Holidays / out-of-office don't count.
const hasRealVisits = computed<boolean>(() =>
  (statsData.futureAppointments ?? 0) > 0 ||
  (calendarData.value?.events ?? []).some(
    e => e.type === AppointmentType.EVENT || e.type === AppointmentType.MANUAL
  )
);
// Only for a genuinely new business: on the trial plan, able to edit, and with no
// real visits yet. Independent of the product tour — this is an empty-state filler.
const showDemoEvents = computed<boolean>(() =>
  canEdit.value &&
  isInTrial.value &&
  !hasRealVisits.value
);

const demoEvents = computed<ICalendarEvent[]>(() => {
  if (!showDemoEvents.value) return [];
  const day = DateTime.fromJSDate(selectedDate.value).toFormat('yyyy-MM-dd');
  const make = (
    n: number, from: string, to: string, duration: number, title: string, color: string, status: AppointmentStatus
  ): ICalendarEvent => ({
    id: `demo-${n}`,
    start: `${day} ${from}`,
    end: `${day} ${to}`,
    title,
    duration,
    status,
    type: AppointmentType.EVENT,
    serviceColor: color,
    class: 'appointment-approved',
    background: false,
    draggable: false,
    providerId: selectedProvider.value
  });
  return [
    make(1, '09:30', '10:15', 0.75, 'תספורת · דנה לוי (לדוגמה)', '#8864ee', AppointmentStatus.APPROVED),
    make(2, '11:00', '12:30', 1.5, 'צבע ופן · מאיה כהן (לדוגמה)', '#22c55e', AppointmentStatus.APPROVED),
    make(3, '14:00', '14:45', 0.75, 'עיצוב גבות · נועה (לדוגמה)', '#f59e0b', AppointmentStatus.VERIFIED)
  ];
});

// The combined `title` (תור ל{שירות} - עבור {לקוח}) truncates poorly in the narrow
// weekly columns, so we render the customer name and service separately using the
// structured fields when available, falling back to `title` for manual/OOO events.
const isManualEvent = (event: ICalendarEvent): boolean =>
  event.type === AppointmentType.MANUAL || event.type === AppointmentType.OUT_OF_OFFICE;

const getEventPrimaryText = (event: ICalendarEvent): string =>
  isManualEvent(event) ? event.title : (event.customerName || event.title);

const getEventSecondaryText = (event: ICalendarEvent): string =>
  isManualEvent(event) ? '' : (event.serviceName ?? '');

// Tight events show the customer name and service combined on a single line, with the
// time range underneath. Roomier ones keep them on separate lines (handled in the
// template).
const getEventTitleLine = (event: ICalendarEvent): string => {
  const primary = getEventPrimaryText(event);
  const secondary = getEventSecondaryText(event);
  return secondary ? `${primary} - ${secondary}` : primary;
};

/** How much room an event actually has, in pixels. */
const eventHeightPx = (event: ICalendarEvent): number =>
  (event.duration ?? 0) * calendarRowHeight.value;

// Layout rules live in @torim-app/utils so the live preview in the scheduling settings
// renders exactly what the calendar will.
const eventLayout = (event: ICalendarEvent) =>
  calendarEventLayout(eventHeightPx(event), currentView.value.key);

const showEventText = (event: ICalendarEvent): boolean => eventLayout(event).showText;

const isRoomyEvent = (event: ICalendarEvent): boolean => eventLayout(event).roomy;

const eventPrimaryTextClass = (event: ICalendarEvent): string => eventLayout(event).primaryTextClass;

const eventSecondaryTextClass = (event: ICalendarEvent): string => eventLayout(event).secondaryTextClass;

const showEventTimeRange = (event: ICalendarEvent): boolean => eventLayout(event).showTimeRange;

const events = computed<ICalendarEvent[]>(() => {
  try {
    if (!calendarData.value?.events?.length) return demoEvents.value;

    // Filter events by selected providers (desktop view with multiple providers)
    const isMultiProviderDesktop = !isMobile.value && providers.value?.length > 1 && selectedProvidersToShow.value.length > 1;
    let filteredEvents = calendarData.value.events;
    if (!isMobile.value && selectedProvidersToShow.value.length > 0 && providers.value?.length > 1) {
      filteredEvents = calendarData.value.events.filter(event =>
        event.providerId ? selectedProvidersToShow.value.includes(event.providerId) : true
      );
    }

    const mappedEvents: ICalendarEvent[] = [];
    for (const event of filteredEvents) {
      let eventClass = 'appointment-approved';
      if (event.type === AppointmentType.OUT_OF_OFFICE || event.type === AppointmentType.MANUAL) eventClass = 'blocked-hour';
      else if (event.status === AppointmentStatus.NO_SHOW) eventClass = 'no-show-appointment';
      else if (event.status === AppointmentStatus.VERIFIED) eventClass = 'appointment';
      else if (event.status === AppointmentStatus.WAITING_FOR_BUSINESS_APPROVAL) eventClass = 'pending-approval-appointment';

      if (event.customerMarkerColor && event.customerMarkerColor !== 'white') {
        eventClass += ` customer-marker-${event.customerMarkerColor}`;
      }

      // Blocks with little vertical room get minimal padding so the text still fits.
      // Height, not length: on a roomy row-height setting a 30-minute visit is tall
      // enough for normal padding.
      if (calendarEventLayout(eventHeightPx(event), currentView.value.key).tight) eventClass += ' short-event';

      const idClass = event.id ? ` appointment-id-${event.id}` : '';

      // In split mode, events without providerId (holidays, OOO) need to appear in all split columns
      if (isMultiProviderDesktop && !event.providerId) {
        for (const providerId of selectedProvidersToShow.value) {
          mappedEvents.push({
            ...event,
            id: `${event.id}-${providerId}`,
            class: eventClass + idClass,
            background: event.type === AppointmentType.OUT_OF_OFFICE,
            draggable: false,
            split: providerId
          });
        }
      } else {
        mappedEvents.push({
          ...event,
          class: eventClass + idClass,
          background: event.type === AppointmentType.OUT_OF_OFFICE,
          draggable: event.type == AppointmentType.EVENT && DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm').diffNow('day').days >= 0,
          split: isMultiProviderDesktop ? event.providerId : undefined
        });
      }
    }
    return [...mappedEvents, ...demoEvents.value];

  } catch (error) {
    console.error('Error processing events:', error);
    return demoEvents.value;
  }
});

// ---- Mobile "List" view — flat, day-grouped agenda built from the same events ----
const isListEvent = (event: ICalendarEvent): boolean =>
  event.type !== AppointmentType.OUT_OF_OFFICE && !(typeof event.id === 'string' && event.id.startsWith('holiday-'));

// Shared week window used by List, Weekly and the range label. For the current
// week it starts at today (skips already-passed days); otherwise at Sunday.
const weekRange = computed(() => {
  const zone = 'Asia/Jerusalem';
  const today = DateTime.local({ zone }).startOf('day');
  const selectedDt = DateTime.fromJSDate(selectedDate.value).setZone(zone, { keepLocalTime: true }).startOf('day');
  const weekStart = selectedDt.startOf('week', { useLocaleWeeks: true });
  const weekEnd = selectedDt.endOf('week', { useLocaleWeeks: true }).startOf('day');
  const isCurrentWeek = today >= weekStart && today <= weekEnd;
  const rangeStart = isCurrentWeek && today > weekStart ? today : weekStart;
  return { today, rangeStart, weekStart, weekEnd };
});

// Full week of the currently selected date, as day rows for WeekCapacityView.
// If that week is the current one, the list starts at today (not Sunday) rather
// than showing already-passed days.
const capacityDays = computed<ICapacityDay[]>(() => {
  const zone = 'Asia/Jerusalem';
  const { today, rangeStart, weekEnd } = weekRange.value;
  // Free-window chips are bounded by the working-hours span of whoever is shown:
  // one employee → their hours; several → the union (so a slot counts as free
  // only when nobody is booked). Uses selectedProvidersToShow so solo employee
  // accounts (where `providers` is empty) still get a span.
  const shownIds = selectedProvidersToShow.value.length
    ? selectedProvidersToShow.value
    : (selectedProvider.value ? [selectedProvider.value] : []);
  const workSpanForDate = (jsDate: Date): { start?: number; end?: number } => {
    let start = 24, end = 0;
    for (const id of shownIds) {
      const r = adminAvailabilityStore.getWorkingHoursRange(id, jsDate);
      if (r.start !== undefined) start = Math.min(start, r.start);
      if (r.end !== undefined) end = Math.max(end, r.end);
    }
    return start < end ? { start, end } : { start: undefined, end: undefined };
  };

  const eventsByDay = new Map<string, ICalendarEvent[]>();
  for (const event of events.value) {
    if (!isListEvent(event)) continue;
    const startDt = DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm', { zone });
    if (!startDt.isValid) continue;
    const key = startDt.toISODate()!;
    if (!eventsByDay.has(key)) eventsByDay.set(key, []);
    eventsByDay.get(key)!.push(event);
  }

  const days: ICapacityDay[] = [];
  for (let cursor = rangeStart; cursor <= weekEnd; cursor = cursor.plus({ days: 1 })) {
    const key = cursor.toISODate()!;
    const dayEvents = (eventsByDay.get(key) ?? []).sort((a, b) => a.start.localeCompare(b.start));
    // Only show a row for working days (or any day that happens to have appointments).
    if (!isWorkingDate(cursor) && dayEvents.length === 0) continue;
    const workRange = workSpanForDate(cursor.toJSDate());
    days.push({
      iso: key,
      label: HEBREW_WEEKDAYS_FULL[cursor.weekday % 7],
      dateNum: cursor.day,
      jsDate: cursor.toJSDate(),
      isToday: cursor.hasSame(today, 'day'),
      events: dayEvents,
      workStart: workRange.start,
      workEnd: workRange.end
    });
  }
  return days;
});

const getListEventStaffName = (event: ICalendarEvent): string =>
  providers.value.find(p => p.userId === event.providerId)?.fullName?.split(' ')[0] ?? '';

const onListItemClick = (event: ICalendarEvent) => {
  const startDt = DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
  const start = startDt.isValid ? startDt.toJSDate() : new Date();
  onEventClick({ ...event, start } as unknown as ICalendarEvent & { start: Date });
};

// Slim day-scoped summary (מאושרים / ממתינים / סה״כ) for the selected day.
// Built per the redesign, but not shown for now — kept ready in the template
// (commented out) for whenever it's needed.
const selectedDayStats = computed(() => {
  const selectedDt = DateTime.fromJSDate(selectedDate.value).startOf('day');
  const dayEvents = events.value.filter(e => {
    if (!isListEvent(e)) return false;
    const startDt = DateTime.fromFormat(e.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
    return startDt.isValid && startDt.hasSame(selectedDt, 'day');
  });
  const approved = dayEvents.filter(e => e.status === AppointmentStatus.APPROVED || e.status === AppointmentStatus.FINISHED).length;
  const pending = dayEvents.filter(e => e.status === AppointmentStatus.WAITING_FOR_BUSINESS_APPROVAL).length;
  return { approved, pending, total: dayEvents.length };
});

// ─────────────────────────────────────────────────────────────────────────────
// Mobile "tablish" views — daily (multi-provider columns) and weekly (compact
// grid). Daily+single keeps vue-cal; list keeps the agenda. See DayColumnsView /
// WeekGridView. Tapping an event opens the same existing drawer as vue-cal.
// ─────────────────────────────────────────────────────────────────────────────
const AVATAR_PALETTE = [
  { bg: '#edeafd', fg: '#6831d0' }, { bg: '#fde7f3', fg: '#be185d' },
  { bg: '#dbeafe', fg: '#1d4ed8' }, { bg: '#fef9c3', fg: '#a16207' },
  { bg: '#dcfce7', fg: '#15803d' },
];
const colorForUser = (userId: string) => {
  let h = 0;
  for (let i = 0; i < (userId?.length ?? 0); i++) h = (h * 31 + userId.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
};
const HEBREW_DOW = ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'];

const selectedProvidersList = computed(() => providers.value.filter(p => selectedProvidersToShow.value.includes(p.userId)));
// The calendar's tasks strip follows the employee filter; showing everyone keeps it to my own tasks.
const tasksAssigneeIds = computed(() => (staffFilterMode.value === 'all' ? undefined : selectedProvidersToShow.value));
const isMultiProviderDay = computed(() =>
  currentView.value.key === 'day' && providers.value.length > 1 && selectedProvidersToShow.value.length > 1
);

const dayColumns = computed(() => selectedProvidersList.value.map(p => {
  const c = colorForUser(p.userId);
  return { userId: p.userId, firstName: (p.fullName || '').split(' ')[0], initials: getInitials(p.fullName), bg: c.bg, fg: c.fg };
}));

// List view: color occupancy blocks by employee. Assigned by position in the
// shown list (not a hash) so colors are always distinct across the team.
const staffColorMap = computed<Map<string, string>>(() => {
  const map = new Map<string, string>();
  selectedProvidersList.value.forEach((p, i) => map.set(p.userId, AVATAR_PALETTE[i % AVATAR_PALETTE.length].fg));
  return map;
});
const staffColorForEvent = (e: ICalendarEvent): string => staffColorMap.value.get(e.providerId ?? '') ?? '#8864ee';
const staffColorLegend = computed<Array<{ id: string; name: string; color: string }>>(() =>
  selectedProvidersList.value.map((p, i) => ({
    id: p.userId,
    name: (p.fullName || '').split(' ')[0],
    color: AVATAR_PALETTE[i % AVATAR_PALETTE.length].fg
  }))
);

const selectedDayEvents = computed<ICalendarEvent[]>(() => {
  const sel = DateTime.fromJSDate(selectedDate.value);
  return events.value.filter(e => {
    if (!isListEvent(e)) return false;
    const dt = DateTime.fromFormat(e.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
    return dt.isValid && dt.hasSame(sel, 'day');
  });
});

const dayHourRange = computed(() => {
  let start = 24, end = 0;
  const ids = selectedProvidersList.value.length ? selectedProvidersList.value.map(p => p.userId) : [selectedProvider.value];
  for (const uid of ids) {
    const r = adminAvailabilityStore.getWorkingHoursRange(uid, selectedDate.value);
    if (r.start !== undefined) start = Math.min(start, Math.floor(r.start));
    if (r.end !== undefined) end = Math.max(end, Math.ceil(r.end));
  }
  if (start > end) return { start: 8, end: 20 };
  return { start, end };
});
// Current hour for the day-columns "now" highlight — only when viewing today.
const dayNowHour = computed<number | undefined>(() =>
  isViewingToday.value ? DateTime.local({ zone: 'Asia/Jerusalem' }).hour : undefined
);

// When each employee is NOT available on the selected day: the gaps around their working
// hours, plus days off and holidays. The day-columns view shades these, so the branch
// calendar shows who is actually in — the single-employee calendar gets the same from
// vue-cal's `specialHours`.
const hourValue = (h: IWorkingHoursItem['from']): number =>
  getNumericHour(typeof h === 'string' ? h : h.name);

const closedRangesForProvider = (userId: string): Array<{ start: number; end: number; label?: string }> => {
  const ranges: Array<{ start: number; end: number; label?: string }> = [];
  const working = adminAvailabilityStore.getEffectiveHoursForDate(userId, selectedDate.value)
    .map(r => ({ start: hourValue(r.from), end: hourValue(r.to) }))
    .filter(r => Number.isFinite(r.start) && Number.isFinite(r.end) && r.end > r.start)
    .sort((a, b) => a.start - b.start);

  if (!working.length) {
    ranges.push({ start: 0, end: 24, label: 'לא עובד/ת' });
  } else {
    if (working[0].start > 0) ranges.push({ start: 0, end: working[0].start });
    for (let i = 0; i < working.length - 1; i++) ranges.push({ start: working[i].end, end: working[i + 1].start });
    if (working[working.length - 1].end < 24) ranges.push({ start: working[working.length - 1].end, end: 24 });
  }

  // Days off and holidays. A holiday carries no providerId — it closes every column.
  const selectedDt = DateTime.fromJSDate(selectedDate.value);
  for (const event of events.value) {
    if (event.type !== AppointmentType.OUT_OF_OFFICE) continue;
    if (event.providerId && event.providerId !== userId) continue;
    const start = DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
    const end = DateTime.fromFormat(event.end, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
    if (!start.isValid || !start.hasSame(selectedDt, 'day')) continue;
    ranges.push({
      start: start.hour + start.minute / 60,
      end: end.isValid ? end.hour + end.minute / 60 : 24,
      label: event.title
    });
  }
  return ranges;
};

// Tapping empty space in an employee's column books for that employee at that time.
const onDayColumnSlotClick = ({ userId, hour }: { userId: string; hour: number }) => {
  const at = DateTime.fromJSDate(selectedDate.value)
    .startOf('day')
    .plus({ minutes: Math.round(hour * 60) });
  addCustomerEvent({ date: at.toJSDate(), providerId: providerForClickedSlot(userId) });
};

// A date is a "working day" if any of the shown providers has effective hours on it.
const isWorkingDate = (dt: DateTime): boolean => {
  const ids = selectedProvidersList.value.length ? selectedProvidersList.value.map(p => p.userId) : [selectedProvider.value];
  return ids.some(uid => adminAvailabilityStore.getEffectiveHoursForDate(uid, dt.toJSDate()).length > 0);
};
// Weekly view shows every working day across the whole week (Sun–Sat), not just from
// today onwards. Falls back to the full week if availability hasn't loaded yet.
const weekDaysList = computed(() => {
  const { weekStart, weekEnd } = weekRange.value;
  const all: Array<{ iso: string; dow: string; dateNum: number; jsDate: Date; working: boolean }> = [];
  for (let d = weekStart; d <= weekEnd; d = d.plus({ days: 1 })) {
    all.push({ iso: d.toISODate()!, dow: HEBREW_DOW[d.weekday % 7], dateNum: d.day, jsDate: d.toJSDate(), working: isWorkingDate(d) });
  }
  const working = all.filter(d => d.working);
  return (working.length ? working : all).map(({ working: _w, ...rest }) => rest);
});
const weekEvents = computed<ICalendarEvent[]>(() => {
  const isos = new Set(weekDaysList.value.map(d => d.iso));
  return events.value.filter(e => {
    if (!isListEvent(e)) return false;
    const dt = DateTime.fromFormat(e.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
    return dt.isValid && isos.has(dt.toISODate()!);
  });
});
// Availability-based hour window across a set of days for the shown providers.
// The view components extend it further so out-of-range events still fit.
const availabilityHourRange = (days: Array<{ jsDate: Date }>): { start: number; end: number } => {
  let start = 24, end = 0;
  const ids = selectedProvidersList.value.length ? selectedProvidersList.value.map(p => p.userId) : [selectedProvider.value];
  for (const day of days) {
    for (const uid of ids) {
      const r = adminAvailabilityStore.getWorkingHoursRange(uid, day.jsDate);
      if (r.start !== undefined) start = Math.min(start, Math.floor(r.start));
      if (r.end !== undefined) end = Math.max(end, Math.ceil(r.end));
    }
  }
  return start < end ? { start, end } : { start: 8, end: 18 };
};
const weekHourRange = computed(() => availabilityHourRange(weekDaysList.value));
const listTrackRange = computed(() => availabilityHourRange(capacityDays.value));
const todayIso = computed(() => DateTime.local({ zone: 'Asia/Jerusalem' }).toISODate() ?? '');
// Current time as a fractional hour — drives the red "now" lines.
const nowFraction = computed<number>(() => {
  const now = DateTime.local({ zone: 'Asia/Jerusalem' });
  return now.hour + now.minute / 60;
});

// Label shown between the controls and the calendar body: the full selected date
// in Daily view, or the visible day range in List / Weekly views.
const HEBREW_WEEKDAYS_FULL = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
const formatDateRange = (a: DateTime, b: DateTime): string =>
  a.month === b.month
    ? `${a.day}–${b.day} ב${HEBREW_MONTHS[b.month - 1]} ${b.year}`
    : `${a.day} ב${HEBREW_MONTHS[a.month - 1]} – ${b.day} ב${HEBREW_MONTHS[b.month - 1]} ${b.year}`;
const calendarRangeLabel = computed<string>(() => {
  if (currentView.value.key === 'day') {
    const dt = DateTime.fromJSDate(selectedDate.value);
    return `יום ${HEBREW_WEEKDAYS_FULL[dt.weekday % 7]} · ${dt.day} ב${HEBREW_MONTHS[dt.month - 1]} ${dt.year}`;
  }
  // Weekly follows the working days actually shown; List runs today → end of week.
  if (currentView.value.key === 'week') {
    const days = weekDaysList.value;
    if (!days.length) return '';
    return formatDateRange(DateTime.fromISO(days[0].iso), DateTime.fromISO(days[days.length - 1].iso));
  }
  const { rangeStart, weekEnd } = weekRange.value;
  return formatDateRange(rangeStart, weekEnd);
});

const onTableEventClick = (event: ICalendarEvent) => {
  const dt = DateTime.fromFormat(event.start, 'yyyy-MM-dd HH:mm', { zone: 'Asia/Jerusalem' });
  onEventClick({ ...event, start: dt.isValid ? dt.toJSDate() : new Date() } as unknown as ICalendarEvent & { start: Date });
};
const onWeekPickDay = (jsDate: Date) => {
  setSelectedDateAtCalendar(DateTime.fromJSDate(jsDate).startOf('day'), false);
  selectMobileView('day');
};

// ─────────────────────────────────────────────────────────────────────────────
// "Pending approval" view — a flat list of every appointment still awaiting the
// business's approval. Fetched separately from the calendar because it is not
// month-scoped: the owner wants everything open in one place, whichever month the
// calendar happens to have loaded.
// ─────────────────────────────────────────────────────────────────────────────
const pendingAppointments = ref<ICalendarEvent[]>([]);
const pendingLoading = ref(false);
const pendingError = ref(false);
const pendingCount = computed(() => pendingAppointments.value.length);

const loadPendingAppointments = async () => {
  if (!manualApproveEnabled.value) {
    pendingAppointments.value = [];
    return;
  }
  pendingLoading.value = true;
  pendingError.value = false;
  try {
    pendingAppointments.value = await AppointmentsApi.fetchPendingAppointments(selectedProvidersToShow.value);
  } catch (e) {
    console.error('Failed to load pending appointments:', e);
    pendingError.value = true;
    pendingAppointments.value = [];
  } finally {
    pendingLoading.value = false;
  }
};

const onPendingEventClick = (event: ICalendarEvent) => {
  trackEvent('pending_appointment_opened');
  onTableEventClick(event);
};

// The little "to the day in the calendar" button — jump to that date in the daily
// view, loading its month first when it sits outside the one already fetched.
const onPendingPickDay = (jsDate: Date) => {
  trackEvent('pending_appointment_day_opened');
  const day = DateTime.fromJSDate(jsDate).startOf('day');
  setSelectedDateAtCalendar(day, false);
  pickerViewDate.value = day.toJSDate();
  checkAndFetchNewMonth(day);
  // Reuse the dropdown's own option object on desktop so the Select keeps showing a
  // selection (it matches by identity).
  currentView.value = calendarViews.value.find(v => v.key === 'day') ?? { title: 'תצוגה יומית', key: 'day' };
};

// Keep the list in step with the staff filter, and never strand the user on a view
// that disappeared because the manual-approve toggle was turned off.
watch(selectedProvidersToShow, () => {
  if (manualApproveEnabled.value) loadPendingAppointments();
}, { deep: true });

watch(manualApproveEnabled, (enabled) => {
  if (enabled) loadPendingAppointments();
  else if (currentView.value.key === 'pending') selectMobileView('day');
});

watch(() => currentView.value.key, (key) => {
  // Refresh on entry so an approval made elsewhere doesn't leave a stale row behind.
  if (key === 'pending') loadPendingAppointments();
});

// Swipe left/right on the mobile day view to step to the next / previous day.
const daySwipeStart = { x: 0, y: 0, t: 0 };
const onDayTouchStart = (e: TouchEvent) => {
  const t = e.changedTouches[0];
  daySwipeStart.x = t.clientX;
  daySwipeStart.y = t.clientY;
  daySwipeStart.t = Date.now();
};
const onDayTouchEnd = (e: TouchEvent) => {
  if (wasRecentlyDragging()) return;
  const t = e.changedTouches[0];
  const dx = t.clientX - daySwipeStart.x;
  const dy = t.clientY - daySwipeStart.y;
  // Only a deliberate, mostly-horizontal flick — ignore taps and vertical scrolls.
  if (Date.now() - daySwipeStart.t > 600 || Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
  // Swipe right → previous day, swipe left → next day.
  changeCalendarDay(dx > 0 ? -1 : 1);
};
const changeCalendarDay = (delta: number) => {
  const base = selectedDate.value ? DateTime.fromJSDate(selectedDate.value) : DateTime.local({ zone: 'Asia/Jerusalem' });
  const next = base.plus({ days: delta }).startOf('day');
  setSelectedDateAtCalendar(next, false);
  checkAndFetchNewMonth(next);
};

const specialHours = computed(() => {
  const res: Record<number, Array<{
    from: number,
    to: number,
    class: string
  }>> = {};
  // Anchor on the currently-visible week so date-specific overrides apply
  // to the correct weekday slots. `day` is the luxon ISO weekday number
  // (1=Mon … 7=Sun), matching how `daysMapping` is keyed elsewhere.
  const selectedDt = DateTime.fromJSDate(selectedDate.value);
  const providerOverrides = adminAvailabilityStore.getOverridesByProvider(selectedProvider.value);
  for (const day of [1, 2, 3, 4, 5, 6, 7]) {
    const dateForDay = selectedDt.set({ weekday: day as 1 | 2 | 3 | 4 | 5 | 6 | 7 });
    const dateStr = dateForDay.toFormat('yyyy-MM-dd');
    const weekday = daysMapping[day];
    const todayAvailability = adminAvailabilityStore.getEffectiveHoursForDate(selectedProvider.value, dateForDay.toJSDate());
    if (todayAvailability.length === 0) {
      res[day] = [{
        from: 0,
        to: 23 * 60,
        class: 'blocked-hour-availability'
      }];
      continue;
    }

    if (todayAvailability.length === 1) {
      res[day] = [];
    } else {
      res[day] = [];
      for (let i = 0; i < todayAvailability.length - 1; i++) {
        res[day].push({
          from: getNumericHour(<string>todayAvailability[i].to) * 60,
          to: getNumericHour(<string>todayAvailability[i + 1].from) * 60,
          class: 'blocked-hour-availability'
        });
      }
    }

    const start = Math.min(...todayAvailability.map(avail => avail.from).map(from => getNumericHour(<string>from)));
    const end = Math.max(...todayAvailability.map(avail => avail.to).map(to => getNumericHour(<string>to)));

    res[day].push(...[
      {
        from: START_OF_DAY * 60,
        to: start * 60,
        class: 'blocked-hour-availability'
      },
      {
        from: end * 60,
        to: END_OF_DAY * 60,
        class: 'blocked-hour-availability'
      }
    ]);

    // Highlight the hours added by ADD-type overrides on this date so they
    // are visually distinct from the regular weekly schedule.
    for (const o of providerOverrides) {
      if (o.type !== AvailabilityOverrideTypeEnum.ADD) continue;
      if (o.startDate > dateStr || o.endDate < dateStr) continue;
      if (o.daysOfWeek?.length && !o.daysOfWeek.includes(weekday)) continue;
      for (const range of o.hours) {
        const fromStr = typeof range.from === 'string' ? range.from : range.from.name;
        const toStr = typeof range.to === 'string' ? range.to : range.to.name;
        res[day].push({
          from: getNumericHour(fromStr) * 60,
          to: getNumericHour(toStr) * 60,
          class: 'override-hour-availability'
        });
      }
    }
  }
  return res;
});

const selectProviderToShow = (providerId: string) => {
  staffFilterTouched = true;
  if (selectedProvidersToShow.value.includes(providerId))
    selectedProvidersToShow.value = selectedProvidersToShow.value.filter(id => id !== providerId);
  else
    selectedProvidersToShow.value.push(providerId);
};

// Shared function to check if we need to fetch data for a new month
const checkAndFetchNewMonth = async (newDate: DateTime) => {
  const newMonth = newDate.startOf('month');

  // Check if we need to load a different month
  if (newMonth.toISODate() !== currentLoadedMonth.value.toISODate()) {
    console.log(`Date changed to new month ${newMonth.toFormat('yyyy-LL')}, loading data...`);
    currentLoadedMonth.value = newMonth;
    const fromDate = newMonth.toISODate();
    const toDate = newMonth.endOf('month').toISODate();

    if (!isMobile.value) monthSwitchLoading.value = true;

    try {
      // Fetch the new month's data (single selected provider vs. multiple)
      console.log('[checkAndFetchNewMonth] selectedProvidersToShow:', selectedProvidersToShow.value, 'isMobile:', isMobile.value);
      if (selectedProvidersToShow.value.length <= 1) {
        await adminHomeStore.fetchBusinessCalendarData(fromDate!, toDate!);
      } else {
        await adminHomeStore.fetchBusinessCalendarDataForProviders(selectedProvidersToShow.value, fromDate!, toDate!);
      }
      console.log('[checkAndFetchNewMonth] Data loaded. eventsLoaded:', eventsLoaded.value, 'monthSwitchLoading:', monthSwitchLoading.value, 'events in store:', calendarData.value?.events?.length);
      calculateAtt();
    } finally {
      monthSwitchLoading.value = false;
      console.log('[checkAndFetchNewMonth] monthSwitchLoading set to false');
    }
  }
};

const clickedDateToggle = async (action: 'next' | 'prev') => {
  const dateInDateTime = DateTime.fromJSDate(selectedDate.value);
  const newDate = dateInDateTime.plus({ [currentView.value.key]: action === 'next' ? 1 : -1 });

  // Update the selected date
  setSelectedDateAtCalendar(newDate, false);

  // Check if we crossed into a new month and need to fetch data
  await checkAndFetchNewMonth(newDate);
};

const hideSidebar = () => {
  selectPreDefineDate.value = undefined;
};

watch(() => selectedDate.value, async (newDate) => {
  console.log('Selected date changed:', newDate);
  // Keep the picker's week/month anchored on the selected date when it changes elsewhere.
  pickerViewDate.value = newDate;
  // Check if we need to fetch data for the new month
  await checkAndFetchNewMonth(DateTime.fromJSDate(newDate));
});

const switchCalendarView = () => {
  calendarOpen.value = !calendarOpen.value;
  trackEvent('calendar_view_toggled', { view: calendarOpen.value ? 'monthly' : 'weekly' });
};

// Browsing months in the expanded picker loads whichever month scrolled into view, and
// that replaces the calendar's events. However the picker closes — the chevron, picking a
// day, or the auto-close when the page scrolls — the day below must end up on the month
// it is actually showing, or it renders the selected date against another month's data
// (i.e. empty). `checkAndFetchNewMonth` no-ops when that month is already loaded.
watch(calendarOpen, (open) => {
  if (open) return;
  pickerViewDate.value = selectedDate.value;
  checkAndFetchNewMonth(DateTime.fromJSDate(selectedDate.value));
});

// Prev/next month arrows shown next to the month/year label once expanded.
const moveCalendarMonth = (direction: -1 | 1) => {
  (calendar.value as { moveBy: (pages: number) => Promise<boolean> } | null)?.moveBy(direction);
};

const setSelectedProvider = (providerId: string) => {
  trackEvent('calendar_provider_changed');
  selectedProvider.value = providerId;
  setProviderId(providerId);
  currentLoadedMonth.value = DateTime.local({ zone: 'Asia/Jerusalem' }).startOf('month');
  tryToLoad();
};

const calculateAtt = () => {
  const visitsDates = [...new Set(calendarData.value.events.filter(e => e.type === AppointmentType.EVENT).map(e => DateTime.fromISO(e.start.split(' ')[0]).toISODate()))];
  const manualDates = [...new Set(calendarData.value.events.filter(e => e.type === AppointmentType.MANUAL).map(e => DateTime.fromISO(e.start.split(' ')[0]).toISODate()))];
  const outOfOfficeDates = [...new Set(calendarData.value.events.filter(e => e.type === AppointmentType.OUT_OF_OFFICE).map(e => DateTime.fromISO(e.start.split(' ')[0]).toISODate()))];
  attributes.value = attributes.value.filter(x => !['visitsDates', 'manualDates', 'outOfOfficeDates'].includes(x.key));
  attributes.value.push({
    key: 'visitsDates',
    dot: true,
    dates: visitsDates
  });
  attributes.value.push({
    key: 'manualDates',
    dot: {
      style: {
        backgroundColor: 'orange'
      }
    },
    dates: manualDates
  });
  attributes.value.push({
    key: 'outOfOfficeDates',
    dot: {
      style: {
        backgroundColor: 'black'
      }
    },
    dates: outOfOfficeDates
  });

  const current = DateTime.fromJSDate(selectedDate.value);
  initialPage.value.day = current.day;
  initialPage.value.week = current.weekNumber;
  initialPage.value.year = current.year;
  initialPage.value.month = current.month;
};

const selectDate = (dateObject: any) => {
  setSelectedDateAtCalendar(DateTime.fromJSDate(dateObject.date).startOf('day'), false);
  const attr = attributes.value?.find(x => x.key === 'selectedDate');
  if (attr)
    attr.dates = dateObject.date;

  // Reset scroll position in the daily view when selecting a new date
  nextTick(() => {
    const vuecalElement = document.querySelector('#amount-appointments');
    if (vuecalElement) {
      vuecalElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
};

const onCalendarPageChange = async (page: any) => {
  const newMonth = DateTime.fromObject({
    year: page[0].year,
    month: page[0].month,
    day: 1
  }, { zone: 'Asia/Jerusalem' }).startOf('month');

  // Use shared function to check and fetch new month data
  await checkAndFetchNewMonth(newMonth);
};

// Which employee a new appointment should start on: the one whose column was clicked
// in the split (multi-employee) view, otherwise whoever the calendar is scoped to.
// Undefined means "let the drawer decide" (the logged-in user).
const providerForClickedSlot = (split?: string | number | null): string | undefined => {
  const fromSplit = split === undefined || split === null ? undefined : String(split);
  if (fromSplit && providers.value.some(p => p.userId === fromSplit)) return fromSplit;
  if (selectedProvidersToShow.value.length === 1) return selectedProvidersToShow.value[0];
  return undefined;
};

// vue-cal sends the clicked date on its own, or `{ date, split }` once the day is split
// into per-employee columns — where the split is the provider's userId.
const onCellClicked = (payload: Date | { date: Date; split?: string | number }) => {
  const isSplitCell = !(payload instanceof Date);
  const clickedDate = isSplitCell ? payload?.date : payload;
  selectPreDefineDate.value = clickedDate;
  addCustomerEvent({
    date: clickedDate,
    providerId: providerForClickedSlot(isSplitCell ? payload?.split : undefined)
  });
};

// Recurring drag: the drop is applied optimistically, then this modal asks whether
// to move just this occurrence or the whole future series before we persist.
const showRecurringDragModal = ref(false);
const recurringDragActionTaken = ref(false);
const recurringDragCtx = ref<{
  id: string;
  recurringManualEventId: string;
  newDate: string;
  hour: number;
  referenceDate: string;
  title: string;
} | null>(null);

const handleRecurringDragAction = async (scope: RecurringActionScope) => {
  const ctx = recurringDragCtx.value;
  if (!ctx) return;
  recurringDragActionTaken.value = true;
  try {
    if (scope === 'instance') {
      await AppointmentsApi.editAppointment(ctx.id, 'drag', ctx.newDate, ctx.hour);
      toast.success('עדכנו את הביקור שלך 😄');
    } else {
      await RecurringEventsApi.updateEntireSeries(ctx.recurringManualEventId, {
        timeFrom: ctx.hour,
        newDate: ctx.newDate,
        referenceDate: ctx.referenceDate
      });
      toast.success('עדכנו את כל האירועים העתידיים 😄');
    }
  } catch (err) {
    if (err === 'Slot is taken') toast.error('נראה שהתור הזה תפוס');
    else toast.error('לא הצלחנו לעדכן את התור');
  } finally {
    recurringDragCtx.value = null;
    adminHomeStore.fetchBusinessCalendarDataSilently();
  }
};

// Dismissing the modal without choosing reverts the optimistic drag.
const onRecurringDragModalVisible = (visible: boolean) => {
  showRecurringDragModal.value = visible;
  if (visible) return;
  const dismissedWithoutChoice = !recurringDragActionTaken.value && !!recurringDragCtx.value;
  recurringDragActionTaken.value = false;
  recurringDragCtx.value = null;
  if (dismissedWithoutChoice) adminHomeStore.fetchBusinessCalendarDataSilently();
};

/**
 * Persist a dragged appointment at its new date/time. Shared by the desktop's native
 * drop and by the touch drag, so both behave identically (including the
 * "this occurrence / whole series" question for a recurring appointment).
 */
const rescheduleDraggedEvent = (id: string, newStart: DateTime, oldDate: Date): boolean => {
  // Demo events are display-only — never send them to the backend.
  if (typeof id === 'string' && id.startsWith('demo-')) return false;
  trackEvent('appointment_drag_dropped');
  try {
    const draggedEvent = adminHomeStore.calendarData.events.find(x => x.id === id);
    const hour = newStart.hour + (newStart.minute / 60);

    // A recurring appointment must ask "this occurrence only / the whole series",
    // exactly like the form-based edit does. Defer persisting until the choice is made.
    if (draggedEvent?.recurringManualEventId) {
      recurringDragCtx.value = {
        id,
        recurringManualEventId: draggedEvent.recurringManualEventId,
        newDate: newStart.toISODate()!,
        hour,
        referenceDate: DateTime.fromJSDate(oldDate).toISODate()!,
        title: draggedEvent.title ?? ''
      };
      recurringDragActionTaken.value = false;
      showRecurringDragModal.value = true;
      return true;
    }

    AppointmentsApi.editAppointment(id, 'drag', newStart.toISODate()!, hour)
      .then(() => {
        toast.success('עדכנו את הביקור שלך 😄');
      })
      .catch(err => {
        console.log(err);
        if (err === 'Slot is taken')
          toast.error('נראה שהתור הזה תפוס');
        else
          toast.error('לא הצלחנו לעדכן את התור');
      }).finally(() => {
      adminHomeStore.fetchBusinessCalendarDataSilently();
    });

    return true; // Accept the drop
  } catch (error) {
    console.error('Failed to reschedule appointment:', error);
    return false; // Reject the drop on API error
  }
};

// Desktop: vue-cal performs the move itself and reports the result here.
const onEventDrop = (event: IVueCalDnDEvent) =>
  rescheduleDraggedEvent(event.event.id, DateTime.fromJSDate(event.event.start), event.oldDate);

// Touch: our own drag reports the snapped start time, on the day being viewed.
const onTouchEventDrop = (event: CalendarDragEvent, minutes: number) => {
  const day = DateTime.fromJSDate(new Date(event.start));
  rescheduleDraggedEvent(
    String(event.id),
    day.startOf('day').plus({ minutes }),
    new Date(event.start),
  );
};

const {
  preview: dragPreview,
  liftedEventId,
  bindNativeDrag,
  wasRecentlyDragging,
  onEventFocus: onCalendarEventFocus,
  onEventTouchStart,
  onEventTouchMove,
  onEventTouchEnd,
} = useCalendarDrag({
  geometry: {
    timeCellHeight: () => calendarRowHeight.value,
    timeFromMinutes: () => START_OF_DAY * 60,
    // vue-cal's own default: one row per hour.
    timeStepMinutes: () => 60,
  },
  onDrop: onTouchEventDrop,
});

// The native drag listeners live on the calendar wrapper so they see every event,
// including ones rendered after mount.
// Phones and tablets drag by long press; anything mouse-driven keeps the native drag.
const isTouch = isTouchPrimary();
const calendarWrapper = ref<HTMLElement | null>(null);
let unbindNativeDrag: (() => void) | undefined;
watch(calendarWrapper, (el) => {
  unbindNativeDrag?.();
  unbindNativeDrag = el ? bindNativeDrag(el) : undefined;
});
onUnmounted(() => unbindNativeDrag?.());

const closeNewEventModal = (changed: boolean) => {
  selectPreDefineDate.value = undefined;
  hideSidebar();
  if (changed)
    try {
      tryToLoad();
    } catch (e) {
      console.log(e);
    }
};

// `preset` carries the clicked calendar slot (date + that column's employee). Opened from
// the action bar there is no slot, so it starts on the day the calendar is showing (at
// midnight — the hour is left for the owner to pick) and the employee it's filtered to.
const addCustomerEvent = (preset?: { date?: Date; providerId?: string }) => {
  trackEvent('schedule_appointment_clicked');
  openDrawer(NewCustomerEvent, {
    preDate: preset?.date ?? selectedDate.value,
    preProviderId: preset?.providerId ?? providerForClickedSlot(),
    close: closeNewEventModal
  }, {
    closable: true,
    title: 'זימון תור ללקוח',
    noPadding: true
  });
};

const addManualEvent = () => {
  trackEvent('add_manual_event_clicked');
  openDrawer(ManualEvent, {
    date: selectPreDefineDate.value,
    close: closeNewEventModal
  }, {
    closable: true,
    title: 'הוספת אירוע ידני',
    noPadding: true
  });
};

const shareSocials = () => {
  trackEvent('share_site_clicked');
  openDrawer(ShareSocials, {}, { title: 'שיתוף אתר הנחיתה' });
  if (adminStore.getBusinessSiteData?.contract?.status === ContractStatus.Trial && !adminStore.getBusinessSiteData?.savedStates?.isSharedLandingPage)
    AdminApi.updateState({ isSharedLandingPage: true })
      .then(() => adminStore.fetchBusinessData())
      .catch(x => console.error(x));
};

// ---- Mobile: docked "..." actions sheet (replaces the old top quick-actions row) ----
const isPaymentAvailable = computed(() => !!(adminStore.businessSiteData?.hasPayments && adminStore.getMainClient));
const isInvoiceAvailable = computed(() => !!(adminStore.businessSiteData?.hasInvoices && adminStore.getMainClient));

const openPaymentModal = (type: 'invoice' | 'payment') => {
  trackEvent('payment_action_clicked', { type });
  openDrawer(SendPaymentRequest, { selectedAction: type }, {
    closable: true,
    title: type === 'payment' ? 'יצירת חיוב' : 'הפקת חשבונית',
    noPadding: true
  });
};

interface IHomeActionItem {
  label: string;
  icon: string;
  action: () => void;
}

// Ordered for the 2×2 RTL grid: invoice (top-right), payment (top-left),
// personal site (bottom-right), add event (bottom-left).
const homeActionsSheetItems = computed<IHomeActionItem[]>(() => {
  const items: IHomeActionItem[] = [];
  if (isInvoiceAvailable.value) items.push({ label: 'יצירת חשבונית', icon: 'pi-receipt', action: () => openPaymentModal('invoice') });
  if (isPaymentAvailable.value) items.push({ label: 'יצירת חיוב', icon: 'pi-credit-card', action: () => openPaymentModal('payment') });
  items.push({ label: 'אתר אישי', icon: 'pi-globe', action: shareSocials });
  items.push({ label: 'הוספת אירוע', icon: 'pi-calendar', action: addManualEvent });
  return items;
});

// The "…" expands the docked bar into an in-place actions panel (not a drawer).
const actionsExpanded = ref(false);
const runAction = (fn: () => void) => {
  actionsExpanded.value = false;
  fn();
};

const actions: Array<{
  label: string;
  desktopLabel: string;
  icon: string;
  action: () => void;
  id: string;
  hideOnDesktop?: boolean
}> = [
  {
    label: 'זימון\n תור',
    desktopLabel: 'זימון תור',
    action: addCustomerEvent,
    icon: 'pi-calendar-plus',
    id: 'schedule-appointment-action-button'
  },
  {
    label: 'הוספת\n אירוע',
    desktopLabel: 'הוספת אירוע',
    action: addManualEvent,
    icon: 'pi-calendar-clock',
    id: 'add-event-action-button'
  },
  {
    label: 'אתר \nאישי',
    desktopLabel: 'אתר אישי',
    action: shareSocials,
    icon: 'pi-share-alt',
    id: 'share-site-action-button',
    hideOnDesktop: true
  }
];

// A task that reserved (or released) calendar time changes the blocks drawn here.
watch(() => tasksStore.calendarVersion, () => tryToLoad());

const modalClose = (shouldReload?: boolean) => {
  if (shouldReload) {
    tryToLoad();
  }
  closeDrawer();
};

const openExampleEvent = (event: ICalendarEvent) => {
  trackEvent('example_event_opened');
  openDrawer(ExampleEventOptions, { event }, {
    title: 'תור לדוגמה',
    noPadding: true,
    full: false
  });
};

const onEventClick = (event: ICalendarEvent & { start: Date }) => {
  // The touch that just dragged this appointment also ends in a tap — don't open it.
  if (wasRecentlyDragging()) return;
  if (typeof event.id === 'string' && event.id.startsWith('holiday-')) return;
  if (typeof event.id === 'string' && event.id.startsWith('demo-')) {
    openExampleEvent(event);
    return;
  }
  if (event.taskId) {
    trackEvent('calendar_task_block_clicked');
    TasksApi.get(event.taskId)
      .then(task => openTaskEditor({ task }))
      .catch(e => console.error(e));
    return;
  }
  trackEvent('calendar_event_clicked', { event_type: event.type });
  openDrawer(ExistingEventOptions, {
    apid: event.id,
    date: event.start,
    currentStepIndex: event.currentStepIndex,
    onClose: modalClose
  }, {
    title: event.type === AppointmentType.OUT_OF_OFFICE ? 'יום ללא עבודה' : 'פרטי התור',
    noPadding: true,
    full: false
  });
};

const tryToLoad = () => {
  isErrorState.value = false;
  calendarLoaded.value = false;
  eventsLoaded.value = false;

  console.log('tryToLoad');
  // Load current month by default
  const now = DateTime.local({ zone: 'Asia/Jerusalem' });
  const fromDate = now.startOf('month').toISODate();
  const toDate = now.endOf('month').toISODate();

  adminStore.getNotifications();
  // Pending-approval list is independent of the calendar's month, so it loads on its
  // own — this also keeps the tab's counter fresh after an approval or cancellation.
  loadPendingAppointments();
  // Fetch for the single selected provider, or all selected providers at once
  const fetchCalendarPromise = selectedProvidersToShow.value.length <= 1
    ? adminHomeStore.fetchBusinessCalendarData(fromDate!, toDate!)
    : adminHomeStore.fetchBusinessCalendarDataForProviders(selectedProvidersToShow.value, fromDate!, toDate!);

  Promise.all([
    adminAvailabilityStore.fetchBusinessAvailability(),
    adminAvailabilityStore.fetchAvailabilityOverrides(),
    fetchCalendarPromise,
    AppointmentsApi.getCalendarStats(selectedProvider.value)
  ]).then(([, , , stats]) => {
    console.log('Loaded admin Home Data');
    Object.assign(statsData, stats);
    calculateAtt();
    dataLoaded.value = true;
    calendarLoaded.value = true;
    eventsLoaded.value = true;
  }).catch(err => {
    dataLoaded.value = false;
    isErrorState.value = true;
    console.error('Failed to load Home:', err);
  });
};

setPage(AdminRouteNames.Home);
tryToLoad();

// When providers load after initial setup, initialize selectedProvidersToShow and re-fetch.
// Driven off the (already permission-scoped) `providers` list, so an employee with the
// branch calendar starts on their whole branch just like the owner does, while everyone
// else stays on their own.
watch(providers, (newProviders) => {
  // Never widen the selection for a user with no staff picker — they stay
  // scoped to their own calendar.
  if (!canManageOthers.value && !canViewBranchCalendar.value) {
    if (adminStore.userId && (selectedProvidersToShow.value.length !== 1 || selectedProvidersToShow.value[0] !== adminStore.userId))
      selectedProvidersToShow.value = [adminStore.userId];
    return;
  }
  if (newProviders?.length && selectedProvidersToShow.value.length === 0) {
    const saved = localStorage.getItem(PROVIDERS_STORAGE_KEY);
    if (saved) {
      const validIds = new Set(newProviders.map(p => p.userId));
      const filtered = (JSON.parse(saved) as string[]).filter(id => validIds.has(id));
      selectedProvidersToShow.value = filtered.length ? filtered : newProviders.map(p => p.userId);
    } else {
      selectedProvidersToShow.value = newProviders.map(p => p.userId);
    }
    tryToLoad();
  }
});

// ── Owner-set calendar defaults (team profile → "ברירת מחדל ליומן") ──
// What the calendar *opens* on, so both the view and the staff scope are applied on every
// load — a remembered filter from a previous session must not quietly outrank the owner's
// setting. Switching view or staff during the session still works normally.
const calendarDefaults = computed(() => adminStore.getBusinessSiteData?.calendarDefaults);
const DEFAULT_VIEW_TITLES: Record<CalendarDefaultView, string> = {
  day: 'תצוגה יומית',
  week: 'תצוגה שבועית',
  list: 'רשימה'
};
let appliedDefaultView = false;
let appliedDefaultScope = false;

const applyCalendarDefaults = () => {
  const defaults = calendarDefaults.value;
  if (!defaults) return;

  const view = defaults.view;
  // The list view is mobile-only; on desktop such a default is simply ignored.
  if (!appliedDefaultView && view && (isMobile.value || view !== 'list')) {
    appliedDefaultView = true;
    currentView.value = calendarViews.value.find(v => v.key === view)
      ?? { title: DEFAULT_VIEW_TITLES[view], key: view };
  }

  // Once the employee picks a staff filter themselves, that's what they're looking at —
  // stop steering it.
  if (staffFilterTouched || !defaults.scope) return;

  if (defaults.scope === 'branch') {
    if (!canManageOthers.value && !canViewBranchCalendar.value) return;
    // `providers` starts as just this user and only grows to the rest of the branch once
    // availability has loaded (branch membership comes from the working-hours blocks), so
    // this re-runs on every change rather than latching on the first, half-loaded list.
    const branchIds = providers.value.map(p => p.userId);
    const current = selectedProvidersToShow.value;
    if (!branchIds.length || (branchIds.length === current.length && branchIds.every(id => current.includes(id)))) return;
    selectedProvidersToShow.value = branchIds;
  } else if (adminStore.userId && !appliedDefaultScope) {
    appliedDefaultScope = true;
    selectedProvidersToShow.value = [adminStore.userId];
  }
};
watch([calendarDefaults, providers], applyCalendarDefaults, { immediate: true, deep: true });

// When the provider filter changes, persist and re-fetch calendar data
watch(selectedProvidersToShow, () => {
  localStorage.setItem(PROVIDERS_STORAGE_KEY, JSON.stringify(selectedProvidersToShow.value));
  if (selectedProvidersToShow.value.length === 0) return;
  const now = DateTime.local({ zone: 'Asia/Jerusalem' });
  const fromDate = currentLoadedMonth.value.toISODate() ?? now.startOf('month').toISODate();
  const toDate = currentLoadedMonth.value.endOf('month').toISODate() ?? now.endOf('month').toISODate();

  if (selectedProvidersToShow.value.length === 1) {
    adminHomeStore.setProviderId(selectedProvidersToShow.value[0]);
    adminHomeStore.fetchBusinessCalendarData(fromDate!, toDate!).then(() => calculateAtt());
  } else {
    adminHomeStore.fetchBusinessCalendarDataForProviders(selectedProvidersToShow.value, fromDate!, toDate!).then(() => calculateAtt());
  }
}, { deep: true });

watch(() => adminHomeStore.getCalendarData, () => {
  calculateAtt();
}, { deep: true });

watch(() => adminStore.notifications.length, (newLen, oldLen) => {
  if (newLen > oldLen) {
    adminHomeStore.fetchBusinessCalendarDataSilently();
  }
});

const route = useRoute();

const focusAppointmentFromNotification = async () => {
  const highlightId = route.query.highlightAppointmentId as string | undefined;
  const appointmentDate = route.query.appointmentDate as string | undefined;
  let providerId = route.query.providerId as string | undefined;
  if (!highlightId) return;

  // Clear the query immediately so back-navigation / re-triggers don't refire.
  router.replace({ name: AdminRouteNames.Home, query: {} });

  const targetMonth = (appointmentDate
    ? DateTime.fromISO(appointmentDate, { zone: 'Asia/Jerusalem' })
    : DateTime.local({ zone: 'Asia/Jerusalem' })).startOf('month');
  const allProviderIds = [...new Set((adminStore.getProviders ?? []).map(p => p.userId))];
  const multiProvider = allProviderIds.length > 1;

  // Older notifications don't carry the provider — find it by loading every provider
  // for the month and locating the event.
  if (multiProvider && !providerId) {
    await adminHomeStore.fetchBusinessCalendarDataForProviders(allProviderIds, targetMonth.toISODate()!, targetMonth.endOf('month').toISODate()!);
    currentLoadedMonth.value = targetMonth;
    providerId = calendarData.value?.events?.find(e => e.id === highlightId)?.providerId;
  }

  // Calendar data is scoped per-provider, so an appointment belonging to another provider
  // isn't loaded/shown until we switch to it. The providerId comes from a trusted
  // notification, so switch unconditionally (don't gate on the local providers list, which
  // is empty for non-managers) and load that provider's month.
  if (multiProvider && providerId && !selectedProvidersToShow.value.includes(providerId)) {
    pickProvider(providerId);
    setProviderId(providerId);
    currentLoadedMonth.value = targetMonth;
    await adminHomeStore.fetchBusinessCalendarData(targetMonth.toISODate()!, targetMonth.endOf('month').toISODate()!);
  }

  if (appointmentDate) {
    const dt = DateTime.fromISO(appointmentDate, { zone: 'Asia/Jerusalem' }).startOf('day');
    if (dt.isValid) {
      // Set the date first so vue-cal initialises with the correct date when
      // it later switches view. If we change both props in the same tick,
      // vue-cal's activeView change can win and snap back to today.
      setSelectedDateAtCalendar(dt, false);
      // Update mobile VCalendar selected-date highlight attribute.
      const selAttr = attributes.value?.find(x => x.key === 'selectedDate');
      if (selAttr) selAttr.dates = dt.toJSDate();
      await nextTick();
      currentView.value = { title: 'תצוגה יומית', key: 'day' };
      await checkAndFetchNewMonth(dt);
    }
  }

  // Wait for vue-cal to render the events for the (possibly new) date.
  await nextTick();
  const deadline = Date.now() + 4000;
  let el: HTMLElement | null = null;
  while (Date.now() < deadline) {
    el = document.querySelector(`.appointment-id-${highlightId}`) as HTMLElement | null;
    if (el) break;
    await new Promise((r) => setTimeout(r, 100));
  }
  if (!el) return;

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.add('appointment-highlighted');
  setTimeout(() => el!.classList.remove('appointment-highlighted'), 3500);
};

watch(() => route.query.highlightAppointmentId, (id) => {
  if (id) focusAppointmentFromNotification();
});

onMounted(async () => {
  try {
    const dismissed = await getValue(REFERRAL_BANNER_STORAGE_KEY);
    if (!dismissed) showReferralBanner.value = true;
  } catch (error) {
    console.error('Error reading referral banner state:', error);
  }

  if (route.query.highlightAppointmentId) focusAppointmentFromNotification();
  const pickerOffset = dateRangePicker.value?.offsetTop ?? 0;
  adminHome.value!.addEventListener('scroll', () => {
    if (!isMobile) return;

    if (dateRangePicker.value) {
      const scrollTop = adminHome.value!.scrollTop;
      const isStickyTriggered = scrollTop >= pickerOffset;
      isCalendarSticky.value = isStickyTriggered;

      if (isStickyTriggered && calendarOpen.value && !automaticallyClosed.value) {
        calendarOpen.value = false;
        automaticallyClosed.value = true;
      } else if (!isStickyTriggered) {
        automaticallyClosed.value = false;
      }
    }
  });
});

watch(refresh, (value) => {
  if (value) {
    tryToLoad();
  }
});

watch(() => isCalendarSticky.value, () => {
  if (isCalendarSticky.value) {
    dateRangePicker.value;
  }
});

</script>

<style lang="scss" scoped>
@use '../../../assets/css/vars' as *;

/* Home docked actions — the "…" morphs the bar in place into the full panel. */
.ha-fade-enter-active,
.ha-fade-leave-active {
  transition: opacity 0.22s ease;
}
.ha-fade-enter-from,
.ha-fade-leave-to {
  opacity: 0;
}

.ha-panel {
  transition: border-radius 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease, border-color 0.3s ease;
}

/* Grabber — takes no space when collapsed, fades in as the panel opens. */
.ha-handle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;
}
.ha-panel--open .ha-handle {
  height: 1.25rem;
  opacity: 1;
}

/* The "…" fades out and collapses its width so the primary button (flex-1)
   stretches to full width in the same motion. */
.ha-dots {
  width: 46px;
  height: 46px;
  margin-inline-start: 0.5rem;
  overflow: hidden;
  transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1), margin 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.15s ease, border-color 0.3s ease;
}
.ha-panel--open .ha-dots {
  width: 0;
  margin-inline-start: 0;
  opacity: 0;
  border-color: transparent;
  pointer-events: none;
}

/* Secondary actions — the row expands from 0 height (grid-rows trick) while the
   buttons fade in with a small slide-up. */
.ha-sec {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.ha-sec > div {
  overflow: hidden;
  min-height: 0;
}
.ha-panel--open .ha-sec {
  grid-template-rows: 1fr;
}
.ha-sec-inner {
  opacity: 0;
  transform: translateY(10px);
  /* Hidden content stays in the DOM (needed for the height animation) — visibility
     keeps it untappable/unfocusable, flipping only after the collapse finishes. */
  visibility: hidden;
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), visibility 0s linear 0.3s;
}
.ha-panel--open .ha-sec-inner {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), visibility 0s;
}

.calendar-wrapper {
  width: calc(100% - 1rem);
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  border: none;

  @media (min-width: 768px) {
    min-height: 0; // Critical: allows flex item to shrink below content size
  }
}

.vuecal {
  width: 100%;
  box-shadow: none;
}

// The mobile month/year label above VCalendar replaces its own built-in
// header — hide the library's default one so it isn't shown twice.
:deep(.vc-header) {
  display: none;
}

// "Delicate" Day-view grid (mobile only, per the redesign) — lighter
// gridlines, hour labels and cell tints. Week view and the event chips
// themselves (the #event slot above) are intentionally left untouched.
.delicate-day-view {
  :deep(.vuecal) {
    box-shadow: none !important;
  }
  :deep(.vuecal__time-column .vuecal__time-cell-line)::before {
    border-top: 1px solid #f1f1f3 !important;
  }
  :deep(.vuecal__time-column .vuecal__time-cell) {
    color: #b3b3b3 !important;
    font-weight: 300 !important;
    font-size: .85em !important;
  }
  :deep(.vuecal__cell)::before {
    border: 1px solid #f1f1f3 !important;
  }
  :deep(.vuecal__cell--today),
  :deep(.vuecal__cell--current) {
    background-color: transparent !important;
  }
  :deep(.vuecal__now-line) {
    border-top-color: rgba(136, 100, 238, .5) !important;
  }
}

.p-ripple.purple .p-ink {
  background: rgba(256, 39, 176, .3);
}

.chip-overrides {
  @apply flex-none border border-solid border-gray-300;
  border-radius: 100rem !important;
}

.chip-overrides-selected {
  @apply flex-none border border-solid rounded-full border-gray-300;
}

.rainbow-text {
  background-image: linear-gradient(to left, violet, indigo, blue, green, yellow, orange, red);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ── Referral card with animated gradient border (matches mobile menu) ── */
.referral-card {
  position: relative;
  width: 100%;
  padding: 2px;
  border-radius: 14px;
  cursor: pointer;
  background: conic-gradient(
    from var(--referral-angle, 0deg),
    #8864ee,
    #ec4899,
    #f59e0b,
    #22c55e,
    #06b6d4,
    #8864ee
  );
  animation:
    referralSpin 4s linear infinite,
    referralFloat 3.2s ease-in-out infinite;
  box-shadow: 0 10px 24px rgba(136, 100, 238, 0.3);
}

@keyframes referralFloat {
  0%, 100% {
    transform: translateY(0);
    box-shadow: 0 10px 24px rgba(136, 100, 238, 0.3);
  }
  50% {
    transform: translateY(-6px);
    box-shadow: 0 16px 28px rgba(136, 100, 238, 0.35);
  }
}

.referral-card__inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

@property --referral-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes referralSpin {
  to { --referral-angle: 360deg; }
}

@supports not (background: conic-gradient(from 0deg, red, blue)) {
  .referral-card {
    background: transparent;
    animation: none;
  }
  .referral-card::before {
    content: '';
    position: absolute;
    inset: -50%;
    background: conic-gradient(#8864ee, #ec4899, #f59e0b, #22c55e, #06b6d4, #8864ee);
    animation: referralSpinFallback 4s linear infinite;
    z-index: 0;
  }
  .referral-card__inner {
    position: relative;
    z-index: 1;
  }
}

@keyframes referralSpinFallback {
  to { transform: rotate(360deg); }
}

</style>

<style lang="scss">
// Global (non-scoped) styles for vue-cal child component elements
.admin-home {
  .vuecal__event {
    // Allow vertical scrolling (pan-y) on events so touching an event and swiping
    // up/down scrolls the page, while horizontal gestures are still captured for DnD
    touch-action: pan-y !important;
    -webkit-user-select: none !important;
    user-select: none !important;
    -webkit-touch-callout: none !important;
  }

  .vuecal__event--dragging-ghost {
    opacity: 0.7 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
    z-index: 10 !important;
  }

  .vuecal__event--dragging-original {
    opacity: 0.5 !important;
  }

  .vuecal__cell--highlighted {
    background-color: rgba(114, 59, 227, 0.1) !important;
  }
}

.vuecal__event.appointment-highlighted {
  outline: 2px solid rgb(136, 100, 238) !important;
  box-shadow: 0 0 0 4px rgba(136, 100, 238, 0.35) !important;
  animation: appointment-highlight-pulse 1.2s ease-in-out 2;
  z-index: 5 !important;
}

@keyframes appointment-highlight-pulse {
  0%, 100% { box-shadow: 0 0 0 4px rgba(136, 100, 238, 0.35); }
  50% { box-shadow: 0 0 0 10px rgba(136, 100, 238, 0.15); }
}
</style>
